// USAGE
// -----
//
// pageview(pageId, languageCode)
// * pageId: a unique page identifier, e.g. 'genetic_science'
// * languageCode: the current locale, e.g. 'en-us'
// <script>
//     TTAM.airprTracking.pageview('home', 'en-ca');
// </script>

TTAM.airprTracking = (function(){
    'use strict';

    // private functions
    // -----------------

    function pageview(pageId, languageCode) {
        // make sure data-layer is in global scope before sending eventData
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            'event': 'gaEvent',
            'gaEventCategory': 'airpr',
            'gaEventAction': pageId + '_pageview',
            'gaEventLabel': languageCode,
            'gaEventValue': 0,
            'gaEventNonInteractionBool': true
        });
    }

    // public API
    // ----------

    return {
        pageview: pageview
    };
})();

// Adds smooth scroll to all anchor links. Accounts for floating header height.
TTAM.anchors = (function() {
    'use strict';

    function matches(element, selector){
        if(element.matches){
            return element.matches(selector);
        }
        return element.msMatchesSelector(selector);
    }

    function getOffset() {
        // Checks for a sticky header. If not sticky - scroll to element and ignores the header height
        var $header = $('.js-ttam-header');
        var $anchorHeader = $('.js-anchor-header');
        var offset = 0;

        if ($anchorHeader.length === 1) {  // sticky nav for Community Landing pages
            offset = $anchorHeader.outerHeight();
        } else if (($header.length === 1) && ($header.css('position') !== 'static')) {  // sticky Website header
            offset = $header.outerHeight();
        }

        return offset;
    }

    // Smooth scrolling: https://css-tricks.com/snippets/jquery/smooth-scrolling/
    function scrollTo($el, e) {
        $('html, body').animate({
            scrollTop: $el.offset().top - getOffset()
        }, 500);

        // move focus
        e.currentTarget.blur();
        $el.tabIndex = -1;
        $el.focus();
    }

    return function() {
        $(document).on('click', 'a[href*="#"]:not([href="#"])', function(e) {
            // TODO: make this configurable
            if (matches(e.target, '[data-veil="toggle"]')) {
                return;
            }

            if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
                var $target = $(this.hash);
                if ($target.length) {
                    e.preventDefault();
                    scrollTo($target, e);
                    $target.focus();
                }
            }
        });
    };
})();

/**
 * Any mangling we need to do for the async markup needs to be done here
 *
 * 1. replace lazy load attribute
 * 2. remove srcset if request took over 500ms
 * 3. make data-src and data-srcset attributes normal src and srcset attributes
 *
 * @param {any} xhrData : data returned from ajax request
 * @param {any} timeTaken : milliseconds it took for the ajax request
 * @returns
 */
function fixMarkup(xhrData, timeTaken) {
    var slowConnectionMS = 500;

    // 1. replace lazy load and default src attribute
    var fixedData = xhrData.replace(/lazy-load src/igm, 'default-src');

    // 2. remove srcset if request took over 500ms
    if (timeTaken > slowConnectionMS) {
        fixedData = fixedData.replace(/data-srcset/igm, 'default-srcset');
    }

    // 3. make data-src and data-srcset attributes normal src and srcset attributes
    fixedData = fixedData.replace(/data-src/igm, 'src');

    return fixedData;
}

TTAM.asyncInclude = function() {
    var asyncIncludes = Array.prototype.slice.call((document.querySelectorAll('[data-async-include]')));

    asyncIncludes.forEach(function getInclude(include) {
        var postData = {
            template: include.getAttribute('data-async-include'),
            lang: include.getAttribute('data-lang'),
            eventName: include.getAttribute('data-event-name')
        };
        var start = performance.now();

        // get markup and replace the span with the include's markup
        $.get('/async-include', postData, function response(data) {
            include.outerHTML = fixMarkup(data, performance.now() - start);
        })
        // trigger an event to note something has been asynchronously loaded
            .then(function asyncIncludeCallback() {
                if (postData.eventName) {
                    $(document).trigger(postData.eventName);
                }
                $(document).trigger('async-include:loaded');
            });
    });
};

window.$buoop = {
    required: {
        e: -4, // IE/Edge is > 4 versions behind
        f: -3, // Firefox is > 3 versions behind
        o: -3, // Opera is > 3 versions behind
        c: -3, // Chrome is > 3 versions behind
        s: -3, // Safari > 3 versions behind
    },
    insecure: true, // Always show banner to any browser with severe security issues.
    api: 2020.01,
    statistics: false, // Opt out of anonymous statistics.
    onshow: function() {
        this.addStyles();
    },
    onclick: function() {
        this.removeStyles();
    },
    onclose: function() {
        this.removeStyles();
    },
    getBannerHeight: function() {
        var banner = document.querySelector('#buorg');
        if (!banner) {
            return null;
        }
        return banner.offsetHeight + 'px';
    },
    addStyles: function() {
        document.documentElement.classList.add('buorg-shown');

        var nav = document.querySelector('.chrome-header__container');
        var link = document.querySelector('.main-skip-link');
        var height = this.getBannerHeight();

        if (!height) {
            return;
        }

        if (nav) {
            nav.style.top = height;
        }
        if (link) {
            link.style.top = height;
        }
    },
    removeStyles: function() {
        document.documentElement.classList.remove('buorg-shown');

        var nav = document.querySelector('#pub-site-header-nav');
        var link = document.querySelector('#pub-main-content-link');

        if (nav) {
            nav.style.removeProperty('top');
        }
        if (link) {
            link.style.removeProperty('top');
        }
    }
};

// excluding from test info page
if (window.location.pathname !== '/test-info/') {
    // (c)2019, MIT Style License <browser-update.org/LICENSE.txt>
    // it is recommended to directly link to this file because we update the detection code
    //(c)2019, MIT Style License <browser-update.org/LICENSE.txt>
    //it is recommended to directly link to this file because we update the detection code
    // eslint-disable-next-line no-unused-vars, no-redeclare
    var $bu_=new function(){var s=this;this.version='3.3.15';this.vsakt={c:'80.0.3987.116',f:73,s:'13.0.4',e:80,i:12,ios:'13.3',samsung:10.2,o:65,e_a:44,o_a:55.2,y:'19.12.3',v:2.10,uc:'12.13'};this.vsinsecure_below={c:74,f:72,s:'11.1.1',e:16,i:11,ios:'12.4.3',samsung:'8.0',o:55,o_a:50,y:'19.6',v:'2.5',uc:'12.10'};this.vsdefault={c:-3,f:-3,s:-1,e:-3,i:11,ios:10,samsung:7.9,o:-3,o_a:-3,y:19.5,v:2.3,uc:12.8,a:535};this.names={c:'Chrome',f:'Firefox',s:'Safari',e:'Edge',i:'Internet Explorer',ios:'iOS',samsung:'Samsung Internet',o:'Opera',o_a:'Opera',e_a:'Edge',y:'Yandex Browser',v:'Vivaldi',uc:'UC Browser',a:'Android Browser',x:'Other',silk:'Silk'};this.get_browser=function(ua){var n,ua=(ua||navigator.userAgent).replace('_','.'),r={n:'x',v:0,t:'other browser',age_years:undefined,no_device_update:false,available:s.vsakt};function ignore(reason,pattern){if(new RegExp(pattern,'i').test(ua))return reason;return false;}r.other=ignore('bot','Pagespeed|pingdom|Preview|ktxn|dynatrace|Ruxit|PhantomJS|Headless|Lighthouse|bot|spider|archiver|transcoder|crawl|checker|monitoring|prerender|screenshot|python-|php|uptime|validator|fetcher|facebook|slurp|google|yahoo|node|mail.ru|github|cloudflare|addthis|thumb|proxy|feed|fetch|favicon|link|http|scrape|seo|page|search console|AOLBuild|Teoma|Expeditor')||ignore('TV','SMART-TV|SmartTV')||ignore('niche browser','OculusBrowser|Falkon|Brave|Classic Browser|Dorado|LBBROWSER|Focus|waterfox|Firefox/56.2|Firefox/56.3|Whale|MIDP|k-meleon|sparrow|wii|Chromium|Puffin|Opera Mini|maxthon|maxton|dolfin|dolphin|seamonkey|opera mini|netfront|moblin|maemo|arora|kazehakase|epiphany|konqueror|rekonq|symbian|webos|PaleMoon|QupZilla|Otter|Midori|qutebrowser')||ignore('mobile without upgrade path or landing page','OPR/44.12.2246|cros|kindle|tizen|silk|blackberry|bb10|RIM|PlayBook|meego|nokia|ucweb|ZuneWP7|537.85.10');r.mobile=(/iphone|ipod|ipad|android|mobile|phone|ios|iemobile/i.test(ua));r.discontinued=(/netscape|greenbrowser|camino|flot|fennec|galeon|coolnovo/i.test(ua));var pats=[['CriOS.VV','c','ios'],['FxiOS.VV','f','ios'],['Trident.*rv:VV','i','i'],['Trident.VV','io','i'],['UCBrowser.VV','uc','c'],['MSIE.VV','i','i'],['Edge.VV','e','e'],['Edg.VV','e','c'],['EdgA.VV','e_a','c'],['Vivaldi.VV','v','c'],['Android.*OPR.VV','o_a','c'],['OPR.VV','o','c'],['YaBrowser.VV','y','c'],['SamsungBrowser.VV','samsung','c'],['Silk.VV','silk','c'],['Chrome.VV','c','c'],['Firefox.VV','f','f'],[' OS.VV.*Safari','ios','ios'],['Version.VV.*Safari','s','s'],['Safari.VV','so','s'],['Opera.*Version.VV','o'],['Opera.VV','o']];var VV='(\\d+\\.?\\d+\\.?\\d*\\.?\\d*)';for(var i=0;i<pats.length;i++)if(ua.match(new RegExp(pats[i][0].replace('VV',VV),'i'))){r.n=pats[i][1];r.engine=pats[i][2];break;}r.fullv=RegExp.$1;r.v=parseFloat(r.fullv);if(/windows.nt.5.0|windows.nt.4.0|windows.95|windows.98|os x 10.2|os x 10.3|os x 10.4|os x 10.5/i.test(ua)){r.no_device_update=true;r.available={};}if(navigator.platform==='MacIntel'&&navigator.maxTouchPoints>1){r.n='ios';r.engine='ios';r.fullv=r.v=13;r.no_device_update=true;}if(/iphone|ipod|ipad|ios/i.test(ua)){ua.match(new RegExp('OS.'+VV,'i'));r.n='ios';r.fullv=RegExp.$1;r.v=parseFloat(r.fullv);r.engine='ios';var av=s.available_ios(ua,r.v);if(av<12&&Math.round(r.v)===11)av=12;r.available={'ios':av};if(parseFloat(r.available.ios)<11)r.no_device_update=true;}if(/windows.nt.5.1|windows.nt.5.2|windows.nt.6.0/i.test(ua))r.available={'c':49.9,'f':52.9};if(/os x 10.6/i.test(ua)){r.available={'s':'5.1.10','c':49.9,'f':48};r.no_device_update=true;}if(/os x 10.7|os x 10.8/i.test(ua)){r.available={'s':'6.2.8','c':49.9,'f':48};r.no_device_update=true;}if(/os x 10.9/i.test(ua))r.available.s='9.1.3';if(/os x 10.10/i.test(ua))r.available.s='10.1.2';if(ua.indexOf('Android')>-1&&r.n==='s'){var v=parseInt((/WebKit\/([0-9]+)/i.exec(ua)||0)[1],10)||2000;if(v<=534){r.n='a';r.fullv=r.v=v;r.is_insecure=true;}}if(r.n==='so'){r.v=r.fullv=4.0;r.n='s';}if(r.n==='io'){r.n='i';if(r.v>6)r.v=11;else if(r.v>5)r.v=10;else if(r.v>4)r.v=9;else if(r.v>3.1)r.v=8;else if(r.v>3)r.v=7;else r.v=9;r.fullv=r.v;}r.t=s.names[r.n]+' '+r.v;r.is_supported=r.is_latest=!s.vsakt[r.n]?undefined:s.less(r.fullv,s.vsakt[r.n])<=0;r.vmaj=Math.round(r.v);r.is_insecure=r.is_insecure||!s.vsinsecure_below[r.n]?undefined:s.less(r.fullv,s.vsinsecure_below[r.n])===1;if((r.n==='f'&&(r.vmaj===68||r.vmaj===60))||(r.n==='i'&&r.vmaj===11)){r.is_supported=true;r.is_insecure=false;if(r.n==='f')r.esr=true;}if(r.n==='ios'&&r.v>10.3)r.is_supported=true;if(r.n==='a'||r.n==='x')r.t=s.names[r.n];if(r.n==='e'){r.t=s.names[r.n]+' '+r.vmaj;r.is_supported=s.less(r.fullv,'18.15063')!=1;}if(r.n in ['c','f','o','e']&&s.less(r.fullv,parseFloat(s.vsakt[r.n])-1)<=0)r.is_supported=true;var releases_per_year={'f':7,'c':8,'o':8,'i':1,'e':1,'s':1};if(releases_per_year[r.n])r.age_years=Math.round(((s.vsakt[r.n]-r.v)/releases_per_year[r.n])*10)/10||0;var engines={e:'Edge.VV',c:'Chrome.VV',f:'Firefox.VV',s:'Version.VV',i:'MSIE.VV','ios':' OS.VV'};if(r.engine){ua.match(new RegExp(engines[r.engine].replace('VV',VV),'i'));r.engine_version=parseFloat(RegExp.$1);}return r;};this.semver=function(vstr){if(vstr instanceof Array)return vstr;var x=(vstr+'.0.0.0').split('.');return [parseInt(x[0])||0,parseInt(x[1])||0,parseInt(x[2])||0,parseInt(x[3])||0];};this.less=function(v1,v2){v1=s.semver(v1);v2=s.semver(v2);for(var i=0;;i++){if(i>=v1.length)return i>=v2.length?0:1;if(i>=v2.length)return -1;var diff=v2[i]-v1[i];if(diff)return diff>0?1:-1;}};this.available_ios=function(ua,v){var h=Math.max(window.screen.height,window.screen.width),pr=window.devicePixelRatio;if(/ipad/i.test(ua)){if(h==1024&&pr==2)return 10;if(h==1112)return 15;if(h==1366)return 15;if(h==1024&&v<6)return 5;return 9;}if(pr==1)return 6;if(h==812)return 11+4;if((h==736||h==667))return 12;if(h==568)return 10;if(h==480)return 7;return 6;};}();window.$bu_getBrowser=$bu_.get_browser;var $buo=function(op,test){var n=window.navigator,b;op=window._buorgres=op||{};var ll=op.l||(n.languages?n.languages[0]:null)||n.language||n.browserLanguage||n.userLanguage||document.documentElement.getAttribute('lang')||'en';op.llfull=ll.replace('_','-').toLowerCase().substr(0,5);op.ll=op.llfull.substr(0,2);op.domain=op.domain!==undefined?op.domain:(/file:/.test(location.href)?'https:':'')+'//browser-update.org';op.apiver=op.api||op.c||-1;op.jsv=$bu_.version;var required_min=(op.apiver<2018&&{i:10,f:11,o:21,s:8,c:30})||{};var vs=op.notify||op.vs||{};vs.e=vs.e||vs.i;vs.i=vs.i||vs.e;var required=op.required||{};required.e=required.e||required.i;if(!required.i){required.i=required.e;$bu_.vsakt.i=$bu_.vsakt.e;}for(b in $bu_.vsdefault){if(vs[b])if($bu_.less(vs[b],0)>=0)required[b]=parseFloat($bu_.vsakt[b])+parseFloat(vs[b])+0.01;else required[b]=parseFloat(vs[b])+0.01;if(!(b in required)||required[b]==null)required[b]=$bu_.vsdefault[b];if($bu_.less(required[b],0)>=0)required[b]=parseFloat($bu_.vsakt[b])+parseFloat(required[b]);if(required_min[b]&&$bu_.less(required[b],required_min[b])===1)required[b]=required_min[b];}required.ios=required.ios||required.s;if(required.i<79&&required.i>65)required.i=required.i-60;if(required.e<79&&required.e>65)required.e=required.e-60;op.required=required;op.reminder=op.reminder<0.1?0:op.reminder||(24*7);op.reminderClosed=op.reminderClosed<1?0:op.reminderClosed||(24*7);op.onshow=op.onshow||function(o){};op.onclick=op.onclick||function(o){};op.onclose=op.onclose||function(o){};op.pageurl=op.pageurl||location.hostname||'x';op.newwindow=(op.newwindow!==false);op.test=test||op.test||(location.hash==='#test-bu')||false;if(Math.random()*1000<1&&!op.test&&!op.nostatistics){var i=new Image();i.src='//browser-update.org/browserstat?jsv='+op.jsv;}op.test=test||op.test||location.hash==='#test-bu';op.ignorecookie=op.ignorecookie||location.hash==='#ignorecookie-bu';op.reasons=[];op.hide_reasons=[];function check_show(op){var bb=op.browser=$bu_.get_browser(op.override_ua);op.is_below_required=required[bb.n]&&$bu_.less(bb.fullv,required[bb.n])===1;if(bb.other!==false)op.hide_reasons.push('is other browser:'+bb.other);if(bb.esr&&!op.notify_esr)op.hide_reasons.push('Extended support (ESR)');if(bb.mobile&&op.mobile===false)op.hide_reasons.push('do not notify mobile');if(op.apiver<2018.5||op.apiver>2020.1)if(bb.is_latest)op.hide_reasons.push('is latest version of the browser');if(bb.no_device_update)op.hide_reasons.push('no device update');if(op.is_below_required)op.reasons.push('below required');if((op.insecure||op.unsecure)&&bb.is_insecure)op.reasons.push('insecure');if(op.unsupported&&!bb.is_supported)op.reasons.push('no vendor support');if(op.hide_reasons.length>0)return false;if(op.reasons.length>0)return true;return false;}op.notified=check_show(op);op.already_shown=document.cookie.indexOf('browserupdateorg=pause')>-1&&!op.ignorecookie;if(!op.test&&(!op.notified||op.already_shown))return;op.setCookie=function(hours){document.cookie='browserupdateorg=pause; expires='+new Date(new Date().getTime()+3600000*hours).toGMTString()+'; path=/; SameSite=None; Secure';};if(op.already_shown&&(op.ignorecookie||op.test))op.setCookie(-10);if(op.reminder>0)op.setCookie(op.reminder);if(op.nomessage){op.onshow(op);return;}var e=document.createElement('script');e.src=op.jsshowurl||op.domain+'/update.show.min.js';document.body.appendChild(e);};$buo(window.$buoop);
}

TTAM.carousels = (function(){
    'use strict';

    var KEYS = {
        enter: 13,
        space: 32,
        tab: 9,
    };

    var selectors = {
        slides: '.js-carousel-slide',
        captions: '.js-carousel-caption',
    };

    function toggleCarousel(){
        $('.js-carousel').each(function(i, carousel){
            var $slides = $(carousel).find(selectors.slides);
            var $captions = $(carousel).find(selectors.captions);
            var triggers = [
                $(carousel).data('trigger') || 'mouseenter',
                'focus'
            ].join(' ');

            var changeSlide = function($slide, $caption){
                $slides.removeClass('is-active');
                $slide.addClass('is-active');
                $captions.removeClass('is-selected');
                $caption.addClass('is-selected');

                // make active caption the first focusable item in list
                $captions.attr('tabindex', '-1');
                $caption.attr('tabindex', '0');
            };

            // when user selects caption, the corresponding image will be displayed
            $captions.each(function(index) {
                var $caption = $(this);

                $caption.on(triggers, function(){
                    var $slide = $slides.eq(index);
                    var $caption = $(this);

                    changeSlide($slide, $caption);
                });

                // move focus to selected slide
                $caption.on('click', function() {
                    $slides.eq(index).focus();
                });

                // recreate button behavior
                $caption.on('keydown', function(e) {
                    var key = e.which || e.keyCode;
                    var $nextCaption;

                    if (key === KEYS.enter || key === KEYS.space) {
                        e.preventDefault();
                        $(this).trigger('click');
                    }

                    // reinstate focus behavior in caption list
                    if (key === KEYS.tab) {
                        $nextCaption = (e.shiftKey) ? $caption.prev(selectors.captions) : $caption.next(selectors.captions);

                        if ($nextCaption.length) {
                            e.preventDefault();
                            $nextCaption.focus();
                        }
                    }

                });
            });
        });
    }

    // Optimizely test: PUB-617 Ancestry - Desktop: Interactive Card Carousel Module Test
    function toggleTabs() {
        $('.js-tabs').each(function(i, tabs){
            var $jsTabModule = $(tabs);
            var $tabs = $jsTabModule.find('.js-tab');
            var $titles = $jsTabModule.find('.js-tab-title');
            var $details = $jsTabModule.find('.js-tab-details');
            $tabs.each(function(index, toggle){
                // when user clicks a tab, the overlay color/title
                // will change and details will display
                $(toggle).on('click', function(event){
                    $tabs.removeClass('is-selected');
                    $titles.removeClass('is-active');
                    $details.removeClass('is-active');
                    $(event.currentTarget).addClass('is-selected');

                    var title = $titles.get(index);
                    var detail = $details.get(index);
                    $(title).addClass('is-active');
                    $(detail).addClass('is-active');
                });
            });
        });
    }

    // public API
    // ----------

    return function(){
        toggleCarousel();
        toggleTabs();
    };

})();
/**
* Polls the cart count cookie (cart_count.[locale])
*
* This will immediately check and set the cart count as well as polling it every
* CART_POLL_INTERVAL ms.
*
* NOTE: this isn't taking into account someone who switches locales between
* adding kits to the cart. It seems we keep a cart count for each locale. Weird.
*/

var MOBILE_BANNER_SELECTOR = '.mobile-banner';
var CART_SELECTOR = '.main-nav-cart';
var CART_DISPLAY = CART_SELECTOR + ' .cart';
var CART_COUNT_SELECTOR = '.js-cart-count';

var CART_DISPLAY_NOT_EMPTY_CLASS = 'not-empty';
var NAV_CART_SHOW_HIDE_CLASSES = {
    SHOW: 'show-cart',
    HIDE: 'show-shop-button'
};

var CART_POLL_INTERVAL = 5000;

// default to 0 which will be the most common case
var persistentCount = 0;

function getCartCount() {
    var cookies = document.cookie;

    if (cookies) {
        if (cookies.indexOf('cart_count') > -1) {
            var cookieList = cookies.split('; ');
            var cookie;

            for (var i = 0; i < cookieList.length; i++) {
                cookie = cookieList[i].split('=');

                if (cookie[0].indexOf('cart_count') > -1) {
                    // make sure the value is a number
                    if (parseInt(cookie[1], 10)) {
                        return cookie[1];
                    }
                    return 0;
                }
            }
        } else {
            return 0;
        }
    } else {
        return 0;
    }
}

TTAM.cart = (function(){
    function setCartCount() {
        var count = getCartCount();

        // don't even run this stuff if it's not needed
        if (count !== persistentCount) {
            persistentCount = count;

            window.requestAnimationFrame(function() {
                var $mobileBanner = $(MOBILE_BANNER_SELECTOR);
                var $cartCountEl = $(CART_SELECTOR + ' ' + CART_COUNT_SELECTOR);
                var $cartDisplay = $(CART_DISPLAY);

                $cartCountEl.text(count);

                if (count) {
                    $cartDisplay.addClass(CART_DISPLAY_NOT_EMPTY_CLASS);

                    if ($mobileBanner.length) {
                        // first check to see if it's hidden or not
                        if ($mobileBanner.hasClass(NAV_CART_SHOW_HIDE_CLASSES.HIDE)) {
                            $mobileBanner.removeClass(NAV_CART_SHOW_HIDE_CLASSES.HIDE);
                            $mobileBanner.addClass(NAV_CART_SHOW_HIDE_CLASSES.SHOW);
                        }
                    }
                } else {
                    $cartDisplay.removeClass(CART_DISPLAY_NOT_EMPTY_CLASS);

                    if ($mobileBanner.length) {
                        // check to see if it's hidden or not
                        if ($mobileBanner.hasClass(NAV_CART_SHOW_HIDE_CLASSES.SHOW)) {
                            $mobileBanner.removeClass(NAV_CART_SHOW_HIDE_CLASSES.SHOW);
                            $mobileBanner.addClass(NAV_CART_SHOW_HIDE_CLASSES.HIDE);
                        }
                    }
                }

            }, this);
        }

        startPollingCart();
    }

    function startPollingCart() {
        return window.setTimeout(setCartCount, CART_POLL_INTERVAL);
    }

    function init(){
        setCartCount();
    }

    // public API
    // ==========

    return function(){
        // exposing just in case we need to get the cart count somewhere else
        this.getCartCount = getCartCount;

        init();
    };
})();

TTAM.chrome = (function(){
    'use strict';

    // private variables
    // -----------------

    // private functions
    // -----------------

    function resizeHeader(){
        // window.pageYOffset for cross-browser compatibility in IE and FF
        if(typeof window.pageYOffset !== 'undefined'){
            var expandableElements = Array.prototype.slice.call(document.querySelectorAll('.js-expandable'));

            expandableElements.forEach(function(expandableElement) {
                if(window.pageYOffset === 0) {
                    expandableElement.classList.add('is-expanded');
                } else {
                    expandableElement.classList.remove('is-expanded');
                }
            });
        }
    }

    function customThrottle(func, wait, options) {
        var context, args, result;
        var timeout = null;
        var previous = 0;
        if (!options) options = {};
        var later = function() {
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        };
        return function() {
            var now = Date.now();
            if (!previous && options.leading === false) previous = now;
            var remaining = wait - (now - previous);
            context = this;
            args = arguments;
            if (remaining <= 0 || remaining > wait) {
                if (timeout) {
                    clearTimeout(timeout);
                    timeout = null;
                }
                previous = now;
                result = func.apply(context, args);
                if (!timeout) context = args = null;
            } else if (!timeout && options.trailing !== false) {
                timeout = setTimeout(later, remaining);
            }
            return result;
        };
    }

    // public API
    // ----------

    return function(){
        // disable for pub update
        // ----------------------

        // excute on document ready
        resizeHeader();

        // listen for window-scroll
        if (!document.querySelector('body.js-sticky-nav')) {
            window.addEventListener('scroll', customThrottle(resizeHeader, 100));
        }
    };
})();

// Sample data
// ===========
// This is an example of the data that we are sending to Google Analytics...
// dataLayer.push({
//     'event': 'gaEvent',
//     'gaEventCategory': 'pubsite',
//     'gaEventAction': 'pubsite_click',
//     'gaEventLabel': 'foo',
//     'gaEventValue': 0
// });
//
// USAGE (init)
// ============
// The clickTracker init-method can be used to initialize click-tracking on a page, e.g...
// <script>
//     // if no configuration needed...
//     TTAM.clickTracker.init();
//     // otherwise, any or all of the following configs can be set...
//     TTAM.clickTracker.init({
//         'gaEventAction': 'world_cup_click',
//         'gaEventValue': 9
//     });
// </script>
// Elements that wish to record click-tracking data should have a data-click-tracker
// attribute with a value that is used to label the event, e.g...
// <div data-click-tracker="gadget"></div>
//
// USAGE (save)
// ============
// The clickTracker save-method can be used to record click-events inline, no need to
// initialize the click-tracker, and no need for data-attributes, it can be referenced
// directly, e.g...
// <div onclick="TTAM.clickTracker.save('gizmo')"></div>
//
// Please see our Google Analytics Documentation...
// https://23andme.atlassian.net/wiki/spaces/BZA/pages/368377876/Google+Analytics+Documentation
// Also check out these links for more context...
// https://developers.google.com/tag-manager/devguide#events
// https://developers.google.com/analytics/devguides/collection/analyticsjs/events
 
TTAM.clickTracker = (function(){
    'use strict';

    // private variables
    // =================

    var selector = '[data-click-tracker]';
 
    var defaults = {
        'gaEventAction': 'pubsite_click',
        'gaEventValue': 0
    };
 
    // private functions
    // =================

    function recordClickEvent(data){
        // make sure data-layer is in global scope
        if(window.dataLayer){
            // add event to data-layer
            window.dataLayer.push(data);
        }
    }

    function handleClick(event){
        var data = event.data;
        // set event-label
        data['gaEventLabel'] = $(this).data('clickTracker');
        // record tracking data
        recordClickEvent(data);
    }

    function getClickData(settings){
        return {
            'event': 'gaEvent', // this will always be the same value
            'gaEventCategory': 'pubsite', // this will always be the same value
            'gaEventAction': settings.gaEventAction,
            'gaEventValue': settings.gaEventValue
        };
    }
 
    function init(configs){
        var settings = $.extend({}, defaults, configs);
        var clickData = getClickData(settings);
        // listen for click-tracker event
        $('body').on('click', selector, clickData, handleClick);
    }

    function save(gaEventLabel){
        var data = getClickData(defaults); // use default-data
        // set event-label
        data['gaEventLabel'] = gaEventLabel;
        // record tracking data
        recordClickEvent(data);
    }
 
    // public API
    // ==========
 
    return {
        // expose init method
        init: init,
        // expose save method
        save: save
    };
})();
/**
 * Special settings for clickable tooltip link (painted door test: PUB-1247)
 */
TTAM.clickableTooltipLink = (function(){
    'use strict';

    function init(keyword){
        Tipped.create($('.js-tooltip-' + keyword), $('.js-text-' + keyword)[0], {
            position: 'bottommiddle',
            skin: 'ttam-light',
            showOn: 'click',
            hideOn: false,
            hideOnClickOutside: true,
            zIndex: 1
        });
    }

    return {
        init: init
    };

})();
TTAM.consoleMessages = (function() {
    'use strict';

    return function() {
        window.setTimeout(function() {
            if (window.console) {
                // eslint-disable-next-line no-console
                console.log('Pssst. We\'re hiring curious devs like you. Contact the team directly at jobs.fasttrack@23andme.com.');
            }
        }, 2000); // Delay so other onload messages can go first.
    };
})();
TTAM.cookies = (function() {
    function _doesCookieExist(name) {
        return document.cookie.split(';').filter(function(item) {
            return item.indexOf(name + '=') >= 0;
        }).length > 0;
    }

    function _makeCookie(name, value, days, domain, secure) {
        var expires = '';
        var path = '; path=/';
        var secureVal = secure ? '; secure' : '';
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toGMTString();
        }
        if (domain) {
            domain = '; domain=' + domain;
        } else {
            domain = '';
        }

        return encodeURIComponent(name) + '=' + encodeURIComponent(value) + expires + domain + path + secureVal;
    }

    function _setCookie(name, value, days, domain, secure) {
        if (typeof days === 'undefined') {
            days = '';
        }

        if (_doesCookieExist(name) || value === '') {
            days = -1;
        }
        if (typeof secure === 'undefined') {
            secure = true;
        }
        document.cookie = _makeCookie(name, value, days, domain, secure);
    }

    function readCookie(name) {
        if (_doesCookieExist(name)) {
            // courtesy of MDN: https://developer.mozilla.org/en-US/docs/Web/API/Document/cookie
            var cookieRE = new RegExp('(?:(?:^|.*;\\s*)' + name + '\\s*\\=\\s*([^;]*).*$)|^.*$');
            return document.cookie.replace(cookieRE, '$1');
        }

        return '';
    }

    function setCookie(name, value, days, domain, secure) {
        if (_doesCookieExist(name)) {
            removeCookie(name);
        }
        if (typeof secure === 'undefined') {
            secure = true;
        }
        _setCookie(name, value, days, domain, secure);
    }

    function removeCookie(name) {
        document.cookie = _setCookie(name, '');
    }

    return {
        set: setCookie,
        remove: removeCookie,
        read: readCookie
    };
}());

// Countdown logic

TTAM.countdown = (function(){
    'use strict';

    // constants
    var msInSecond = 1000;
    var msInMinute = msInSecond * 60;
    var msInHour = msInMinute * 60;
    var msInDay = msInHour * 24;

    function startClock(settings){
        if (!settings.nowUnix || !settings.endUnix) {
            return;
        }

        var diff = settings.endUnix - settings.nowUnix,
            dur = diff,
            daysEl = document.querySelector('[data-cd="days"]'),
            hoursEl = document.querySelector('[data-cd="hours"]'),
            minutesEl = document.querySelector('[data-cd="minutes"]'),
            secondsEl = document.querySelector('[data-cd="seconds"]'),
            dd,
            hh,
            mm,
            ss,
            tempDur;

        if (diff > 0) {
            setInterval(function() {
                dur = dur - 1;
                tempDur = dur * msInSecond;

                dd = (tempDur < msInDay) ? 0 : Math.floor(tempDur / msInDay);
                tempDur -= dd * msInDay;

                hh = (tempDur < msInHour) ? 0 : Math.floor(tempDur / msInHour);
                tempDur -= hh * msInHour;

                mm = (tempDur < msInMinute) ? 0 : Math.floor(tempDur / msInMinute);
                tempDur -= mm * msInMinute;

                ss = (tempDur < msInSecond) ? 0 : Math.floor(tempDur / msInSecond);

                dd = dd < 10 ? '0' + dd : dd;
                hh = hh < 10 ? '0' + hh : hh;
                mm = mm < 10 ? '0' + mm : mm;
                ss = ss < 10 ? '0' + ss : ss;

                if (daysEl) {
                    daysEl.textContent = dd;
                }
                if (hoursEl) {
                    hoursEl.textContent = hh;
                }
                if (minutesEl) {
                    minutesEl.textContent = mm;
                }
                if (secondsEl) {
                    secondsEl.textContent = ss;
                }

                document.querySelector('[data-cd]').classList.add('mod-visible');
            }, msInSecond);
            return true;
        } else {
            return false;
        }
    }

    function init(settings) {
        return startClock(settings);
    }

    // public API
    // ==========
    return function(settings) {
        // initialize component
        return init(settings);
    };
})();

TTAM.drawers = function() {
    'use strict';

    // Usage
    // Trigger:
    //     <button aria-controls="drawer-one" aria-expanded="false">
    //         ...
    //     </button>

    // Alt trigger:
    //     <a href="#drawer-one" data-drawer aria-controls="drawer-one" aria-expanded="false">
    //         ...
    //     </a>

    // Element to expand:
    //     <div id="drawer-one" class="u-hide">
    //         ...
    //     </div>

    // Indicator element (elements to just apply state classes to):
    //     <div data-drawer-indicator="drawer-one">
    //         ...
    //     </div>

    var speed = 500;
    var classes = {
        'open': 'drawer-open',
        'transition': 'drawer-transition'
    };

    function toggle(triggerEl, ids) {
        // CASE: multiple ids
        var idList = ids.trim().split(/\s+/);

        var elSelector = idList.map(function(id) {
            return '#' + id;
        }).join(', ');

        var indicatorsSelector = idList.map(function(id) {
            return '[data-drawer-indicator="' + id + '"]';
        }).join(', ');

        var $el = $(elSelector);
        var $triggers = $('[aria-controls="' + ids + '"]');
        var $indicators = $(indicatorsSelector).add($triggers).add($el);
        var expanded = $($triggers[0]).attr('aria-expanded') === 'true'; // Just grab the first one.
        $indicators.addClass(classes.transition);

        if (expanded) {
            $el.slideUp(speed, function() {
                $triggers.attr('aria-expanded', 'false');
                $indicators.removeClass(classes.transition);
                $indicators.removeClass(classes.open);
                triggerEl.focus();
            });
        } else {
            $el.slideDown(speed, function() {
                $triggers.attr('aria-expanded', 'true');
                $el.focus();
            });
            $indicators.addClass(classes.open);
        }
    }

    $(document).on('click', '[data-drawer]', function() {
        var ids = $(this).attr('aria-controls');
        toggle(this, ids);
        return false;
    });
};

TTAM.dropdownMenu = (function(){

    'use strict';

    // private variables
    // =================

    var expandedAttribute = 'aria-expanded';
    var hoverAttribute = 'data-hover';
    var lockDocumentAttribute = 'data-lock-document';
    var transitionAttribute = 'data-transition';
    // CSS classes
    var hiddenClass = 'is-hidden';
    var lockedClass = 'is-veiled';
    var openClass = 'is-open';
    // query selectors
    var componentSelector = '.js-component-submenu';
    var submenuSelector = '.js-component-submenu-panel';
    var closeSelector = '.js-component-submenu-close-panel';
    var triggerSelector = '[aria-expanded]';
    // default config values
    var transitionProperty = 'height';
    var lockDocument = false;
    var hoverEnabled = false;
    // overrides
    var forceDisableHover = false;
    // keys
    var KEYS = {
        enter: 13,
        esc: 27,
        space: 32,
    };

    // private functions
    // =================

    function each(elements, callback){
        var length = elements.length;
        var i = 0;
        for(; i < length; i++){
            callback(elements[i], i);
        }
    }

    function matches(element, selector){
        if(element.matches){
            return element.matches(selector);
        }
        return element.msMatchesSelector(selector);
    }

    function closest(element, selector){
        if(element.closest){
            return element.closest(selector);
        }
        while(element && element.nodeType === 1){
            if(matches(element, selector)){
                return element;
            }
            element = element.parentNode;
        }
        return null;
    }

    // component definition
    // ====================

    var DropdownMenu = function(el) {
        this.el = el;
        this.trigger = el.querySelector(triggerSelector);
        this.submenu = el.querySelector(submenuSelector);
        this.closeTimer = null;
        this.init();
    };

    var _proto = DropdownMenu.prototype;

    _proto.isExpanded = function() {
        return this.trigger.getAttribute(expandedAttribute) === 'true';
    };

    _proto.toggle = function() {
        this.isExpanded() ? this.close() : this.open();
    };

    _proto.open = function() {
        this.trigger.setAttribute(expandedAttribute, 'true');
        this.submenu.classList.add(openClass);
        this.submenu.classList.remove(hiddenClass);
        this.lockDocumentScrolling();
    };

    _proto.close = function() {
        this.trigger.setAttribute(expandedAttribute, 'false');
        this.submenu.classList.remove(openClass);
    };

    _proto.hide = function() {
        if (!this.isExpanded()) {
            this.submenu.classList.add(hiddenClass);
            this.unlockDocumentScrolling();
        }
    };

    _proto.lockDocumentScrolling = function() {
        if(this.lockDocument){
            document.querySelector('body').classList.add(lockedClass);
        }
    };

    _proto.unlockDocumentScrolling = function() {
        if(this.lockDocument){
            document.querySelector('body').classList.remove(lockedClass);
        }
    };

    _proto.scheduleClose = function(milliseconds) {
        this.closeTimer = setTimeout(this.close.bind(this), milliseconds || 250);
    };

    _proto.cancelClose = function() {
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
    };

    _proto.isHoverable = function() {
        return this.hoverEnabled && !forceDisableHover;
    };

    _proto.bindEvents = function() {
        // Toggle submenu on click. Disabled if hover enabled.
        this.trigger.addEventListener('click', function() {
            if (!this.isHoverable()) {
                this.toggle();
            }
        }.bind(this));

        // Hide submenu from keyboards and screen readers
        // after transition. Use visibility: hidden to hide
        // and retain transition.
        this.submenu.addEventListener('transitionend', function(e) {
            if (e.propertyName === this.transitionProperty) {
                this.hide();
            }
        }.bind(this));

        // Close the open submenu when a close-button is clicked
        this.submenu.addEventListener('click', function(e) {
            var closeButton = closest(e.target, closeSelector);
            if (closeButton) {
                this.close();
                this.trigger.focus();
            }
        }.bind(this));

        // Schedule close when submenu item loses focus
        this.el.addEventListener('focusout', function(){
            this.scheduleClose();
        }.bind(this));

        // Cancel close if submenu item is focused
        this.el.addEventListener('focusin', this.cancelClose.bind(this));

        // When submenu is clicked, the submenu item loses focus,
        // so we need to cancel the timeout
        this.el.addEventListener('mousedown', function() {
            // wait for element to lose focus
            setTimeout(this.cancelClose.bind(this), 10);
        }.bind(this));

        // Close submenu when user clicks outside menu
        document.addEventListener('click', function(e) {
            if (!this.el.contains(e.target)) {
                this.close();
            }
        }.bind(this));

        // Close submenu when esc key is pressed
        this.el.addEventListener('keyup', function(e) {
            var key = e.which || e.keyCode;

            if (key === KEYS.esc) {
                this.trigger.focus();
                this.close();
            }
        }.bind(this));

        // bind mouse-events if hover-config enabled
        if(this.hoverEnabled) {

            // Open submenu on hover
            this.el.addEventListener('mouseenter', function() {
                if (!this.isHoverable()) {
                    return;
                }

                this.open();
            }.bind(this));

            // Close submenu after mouseout
            this.el.addEventListener('mouseleave', function() {
                if (!this.isHoverable()) {
                    return;
                }

                this.close();
            }.bind(this));

            // Toggle submenu on keyup for keyboard users
            this.trigger.addEventListener('keyup', function(e) {
                if (!this.isHoverable()) {
                    return;
                }

                var key = e.which || e.keyCode;

                if (key === KEYS.enter || key === KEYS.space) {
                    this.toggle();
                }
            }.bind(this));

            // Toggle submenu on touch for touch device users
            this.trigger.addEventListener('touchend', function() {
                if (!this.isHoverable()) {
                    return;
                }

                this.toggle();
            }.bind(this));

        }
    };

    _proto.setConfigs = function() {
        this.hoverEnabled = (this.el.getAttribute(hoverAttribute) === 'true') || hoverEnabled;
        this.transitionProperty = this.el.getAttribute(transitionAttribute) || transitionProperty;
        this.lockDocument = (this.el.getAttribute(lockDocumentAttribute) === 'true') || lockDocument;
    };

    _proto.init = function() {
        this.setConfigs();
        this.bindEvents();
    };

    // public API
    // ==========

    var init = function(selector) {
        var components = document.querySelectorAll(selector || componentSelector);
        each(components, function(component) {
            new DropdownMenu(component);
        });
    };

    var disableHover = function() {
        forceDisableHover = true;
    };

    return {
        init: init,
        disableHover: disableHover,
    };

})();

TTAM.emailCapture = (function() {
    var captureForms = document.querySelectorAll('.js-email-capture-form');

    function captureSubmit(e) {
        e.preventDefault();

        // TODO: make this work with other locales
        window.location.href = '/compare-dna-tests/';
    }

    for (var i = 0; i < captureForms.length; i++) {
        captureForms[i].addEventListener('submit', captureSubmit, false);
    }
}());

TTAM.emailForm = (function() {

    'use strict';

    // private variables
    // =================

    var forms = [];
    var formSelector = '[data-email-form]';
    var emailCaptureCookie = 'ttam_email_capture_email';

    var options = {};
    var defaults = {
        campaign: null,
        tokenSelector: '[name="csrfmiddlewaretoken"]',
        emailInputSelector: 'input[name="email"]',
        emailErrorMsgSelector: '.error-email',
        successMsg: '<p class="email-form-success">Thank you.</p>',
        errorMsg: '<p class="email-form-error">Hmm, there seems to be an error. Please try again later.</p>',
        isValid: function() {
            return true;
        },
        onSuccess: null
    };

    // private functions
    // =================

    var isValidEmail = function(email) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    };

    var showError = function(emailInput, errorMsg) {
        errorMsg.style.display = 'block';
        emailInput.setAttribute('aria-describedby', errorMsg.id || '');
        emailInput.setAttribute('aria-invalid', 'true');
        emailInput.focus();
    };

    var hideError = function(emailInput, errorMsg) {
        errorMsg.style.display = 'none';
        emailInput.removeAttribute('aria-describedby');
        emailInput.removeAttribute('aria-invalid');
    };

    var handleSubmit = function(e) {
        e.preventDefault();

        // elements
        var form = e.target;
        var emailInput = form.querySelector(options.emailInputSelector);
        var errorMsg = document.querySelector(options.emailErrorMsgSelector);

        // form values
        var endpoint = '/api/email-capture';
        var email = emailInput.value;
        var source = window.location.pathname;
        var locale = document.documentElement.lang;
        var data = {
            email: email,
            campaign: options.campaign,
            locale: locale,
            source: source,
        };
        // validate form
        var hasValidEmail = isValidEmail(email);

        if (hasValidEmail) {
            hideError(emailInput, errorMsg);
        } else {
            showError(emailInput, errorMsg);
        }

        if (!(options.isValid() && hasValidEmail)) {
            return;
        }

        // show success message
        form.innerHTML = options.successMsg;
        options.onSuccess && options.onSuccess();

        $.ajax({
            url: endpoint,
            type: 'POST', // method
            data: data,
            dataType: 'json',
            error: function() {
                form.innerHTML = options.errorMsg;
            },
            success: function() {
                if (window.TTAM && window.TTAM.cookies) {
                    window.TTAM.cookies.set(emailCaptureCookie, email, undefined, '.23andme.com', true);
                }
            }
        });
    };

    var bindEvents = function() {
        _.forEach(forms, function(form) {
            form.addEventListener('submit', handleSubmit);
        });
    };

    var init = function(selector, args) {
        selector = selector || formSelector;
        options = Object.assign({}, defaults, args);
        forms = document.querySelectorAll(selector);

        bindEvents();
    };

    return {
        init: init
    };

})();
TTAM.externalLinks = (function () {
    function externalLinkHandler(e) {
        if (e.target.classList.contains('js-external')) {
            e.preventDefault();

            var link = e.target;
            var url = link.getAttribute('data-href');
            var linkDisplay = e.target.getAttribute('data-leaving-text') || '';
            var redirectTiming = e.target.getAttribute('data-leaving-timing') || 5;
            var pagePath = 'leaving/';

            var intlPrefix = (function getIntlPrefix() {
                var path = window.location.pathname;
                var pathRE = new RegExp('^/en-[egic][ubna][t]?/');
                var pathMatch = path.match(pathRE);
                if (pathMatch) {
                    return pathMatch[0];
                } else {
                    return '/';
                }
            }());

            var newLocation = intlPrefix + pagePath + '?redirect_to=' + url;

            if (redirectTiming !== 5) {
                newLocation += '&redirect_timing=' + redirectTiming;
            }

            if (linkDisplay.length) {
                newLocation += '&display_text=' + linkDisplay;
            }

            window.open(newLocation, '_blank');
        }
    }

    document.body.addEventListener('click', externalLinkHandler, false);
}());

function findParentByTag(el, parentTagName) {
    var elTag = el.tagName.toLowerCase();
    if (elTag === parentTagName) {
        return el;
    } else if (elTag === 'body') {
        return '';
    } else {
        return findParentByTag(el.parentNode, parentTagName);
    }
}

TTAM.featureSwitches = (function() {
    var featuresDiv;
    var featuresDivClosed;
    var featuresDivOpen;
    var featureValueMap = {
        'on': true,
        'off': false,
    };

    function _callFeaturesFunction(e) {
        var el = findParentByTag(e.target, 'a');

        if (!el.tagName.toLowerCase() === 'a') {
            return;
        }

        var featureFunction = el.getAttribute('data-function');
        if (!featureFunction) {
            return e;
        }
        var featureName = el.getAttribute('data-feature') || '';
        var featureValue = el.getAttribute('data-value') || '';

        if (featureFunction) {
            switch (featureFunction) {
            case 'open':
                _openFeatures();
                break;
            case 'close':
                _closeFeatures();
                break;
            case 'clearAll':
                _clearAllFeatures();
                break;
            default:
                if (typeof TTAM.featureSwitches[featureFunction] === 'function') {
                    TTAM.featureSwitches[featureFunction](featureName, featureValueMap[featureValue]);
                    window.location = window.location.origin + window.location.pathname;
                }
                break;
            }
        }
    }

    function _clearAllFeatures() {
        var featureLinks = featuresDiv.querySelectorAll('[data-forced]');

        for (var i = 0; i < featureLinks.length; i++) {
            var link = featureLinks[i];
            var featureName = link.getAttribute('data-feature') || '';
            var featureValue = featureValueMap[link.getAttribute('data-value')];

            TTAM.featureSwitches.setFeature(featureName, featureValue);
        }

        window.location = window.location.origin + window.location.pathname;
    }

    function _closeFeatures() {
        _getFeaturesDiv();
        featuresDivClosed.classList.remove('u-hide');
        featuresDivOpen.classList.add('u-hide');
    }

    function _getFeaturesDiv() {
        if (!featuresDiv) {
            featuresDiv = document.querySelector('.feature-switches');
        }
        try {
            featuresDivClosed = featuresDiv.querySelector('.feature-switches-closed');
            featuresDivOpen = featuresDiv.querySelector('.feature-switches-open');
        } catch (err) {
            // nothing
        }
    }

    function _openFeatures() {
        _getFeaturesDiv();
        featuresDivClosed.classList.add('u-hide');
        featuresDivOpen.classList.remove('u-hide');
    }

    function readFeatureCookie(name) {
        if (TTAM.cookies.doesCookieExist(name)) {
            return TTAM.cookies.read(name);
        }

        return '';
    }

    function setFeatureCookie(name, value) {
        TTAM.cookies.set(name, value);
    }

    function removeFeatureCookie(name) {
        document.cookie = TTAM.cookies.remove(name, '', -1);
    }

    function init() {
        _getFeaturesDiv();

        featuresDiv.addEventListener('click', _callFeaturesFunction, false);
    }

    return {
        setFeature: setFeatureCookie,
        removeFeature: removeFeatureCookie,
        readFeature: readFeatureCookie,
        clearAll: _clearAllFeatures,
        init: init
    };
}());

/**
 * Traps focus in element. When user tabs past last or first focusable element,
 * focus is reset to first focusable element in element.
 *
 * TODO: Figure how to move focus to last element when user tabs backwards
 * past first element.
 *
 * Usage:
 *
 * // pass in element that focus should be trapped in
 * var focusTrap = TTAM.focusTrap(el);
 *
 * // enable focus trap
 * focusTrap.enable();
 *
 * // disable focus trap
 * focusTrap.disable();
 *
 */
TTAM.focusTrap = (function() {
    var FocusTrap = function(el) {
        this.el = el;
        this.handleFocus = this.handleFocus.bind(this);
    };

    FocusTrap.prototype.getFocusableElements = function() {
        return this.el.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    };

    FocusTrap.prototype.getFirstFocusableElement = function() {
        var focusables = this.getFocusableElements();

        return focusables.length ? focusables[0] : null;
    };

    FocusTrap.prototype.handleFocus = function(e) {
        var firstFocusable;

        if (!this.el.contains(e.target)) {
            firstFocusable = this.getFirstFocusableElement();

            if (firstFocusable) {
                e.preventDefault();
                firstFocusable.focus();
            }
        }
    };

    FocusTrap.prototype.enable = function() {
        document.addEventListener('focusin', this.handleFocus);
    };

    FocusTrap.prototype.disable = function() {
        document.removeEventListener('focusin', this.handleFocus);
    };

    return FocusTrap;
})();

// Trigger fonts.com tracking request. See _fonts.scss
TTAM.fonts = (function() {
    'use strict';

    return function() {
        var projectId = 'b8fd4cd3-2fb0-4055-aa42-f9f169645968';
        var href = 'https://fast.fonts.net/t/1.css?apiType=css&projectid=' + projectId;
        $.get(href);
    };
})();

// USAGE: listenForEcommerceClicks
// -------------------------------
// <script>
//     TTAM.ready(function(){
//         TTAM.ga4.listenForEcommerceClicks();
//     });
// </script>

// USAGE: sendEcommerceData
// ------------------------
// <script>
//     TTAM.ready(function(){
//         TTAM.ga4.sendEcommerceData('view_item', '99', '79');
//     });
// </script>

// USAGE: sendRetailData
// ------------------------
// <script>
//     TTAM.ready(function(){
//         TTAM.ga4.sendRetailData('view_item', 'health');
//     });
// </script>

TTAM.ga4 = (function(){
    'use strict';

    function formatPrice(price) {
        var formattedPrice = +price;
        return formattedPrice || 0;
    }

    function getEcommerceData(originalPrice, discountedPrice) {
        var value = formatPrice(originalPrice);
        var price = formatPrice(discountedPrice) || value;
        var discount = value - price;
        return {
            currency: 'USD',
            items: [{
                discount: discount,
                item_brand: '23andMe',
                item_category: 'DNA Kits',
                item_category2: 'ROW Ancestry',
                item_category3: 'Ancestry + Traits',
                item_id: '65',
                item_name: 'int_anc',
                price: price,
                quantity: 1
            }],
            value: value
        };
    }

    function sendEcommerceData(eventName, originalPrice, discountedPrice) {
        // make sure dataLayer is defined
        window.dataLayer = window.dataLayer || [];
        // clear the previous ecommerce object
        window.dataLayer.push({ ecommerce: null });
        // send event-data
        window.dataLayer.push({
            event: eventName,
            ecommerce: getEcommerceData(originalPrice, discountedPrice)
        });
    }

    function getRetailData(productID) {
        var isAncestry = productID === 'ancestry';
        var ancestry_data =  {
            discount: 0,
            item_brand: '23andMe',
            item_category: 'DNA Kits',
            item_category2: 'US Ancestry',
            item_category3: 'Ancestry + Traits',
            item_id: '74',
            item_name: 'us_ancestry_retail_unlock',
            price: 69,
            quantity: 1
        };
        var health_data =  {
            discount: 0,
            item_brand: '23andMe',
            item_category: 'DNA Kits',
            item_category2: 'US Health',
            item_category3: 'Health + Ancestry',
            item_id: '67',
            item_name: 'us_health_retail_unlock',
            price: 169,
            quantity: 1
        };
        return {
            currency: 'USD',
            items: [isAncestry ? ancestry_data : health_data],
            value: isAncestry ? 69 : 169
        };
    }

    function sendRetailData(eventName, productID) {
        // make sure dataLayer is defined
        window.dataLayer = window.dataLayer || [];
        // clear the previous ecommerce object
        window.dataLayer.push({ ecommerce: null });
        // send event-data
        window.dataLayer.push({
            event: eventName,
            ecommerce: getRetailData(productID)
        });
    }

    function handleEcommerceClick(event) {
        var target = event.target.closest('[data-price]');
        if(target){
            var originalPrice = target.getAttribute('data-price');
            var discountedPrice = target.getAttribute('data-discounted-price');
            sendEcommerceData('add_to_cart', originalPrice, discountedPrice);
        }
    }

    function listenForEcommerceClicks() {
        var href = 'https://store.23andme.com/en-int/cart/?ancestrykit=1';
        var anchors = document.querySelectorAll('a[href="' + href + '"]');
        anchors.forEach(function(anchor){
            anchor.addEventListener('click', handleEcommerceClick);
        });
    }

    return {
        listenForEcommerceClicks: listenForEcommerceClicks,
        sendEcommerceData: sendEcommerceData,
        sendRetailData: sendRetailData
    };
})();

TTAM.LocationRedirects = (function() {
    function hideGDPRWarning(e) {
        e.preventDefault();

        var gdprWarning = document.getElementById('js-gdpr-warning');
        var changeLocationModal = document.getElementById('change-location-modal');

        gdprWarning.classList.remove('show');
        changeLocationModal.focus();
    }

    function redirectUser(form) {
        var path = window.location.pathname.replace(/^\/en-(ca|gb|eu|int)\//, '/');
        var params = window.location.search;
        var countryToRedirect = form.language.value;
        var pathToRedirect = '/' + countryToRedirect + path + params;
        var cookieName = 'selected_country';
        var cookieValue = 'en_' + countryToRedirect.substr(3).toUpperCase();
        if (path.indexOf(countryToRedirect) === -1) {
            TTAM.cookies.set(cookieName, cookieValue);
            window.location.replace(pathToRedirect);
        }
    }

    function checkLocationSubmit(e) {
        if (e.target.classList.contains('location-selector-form')) {
            e.preventDefault();

            var locationForm = e.target;
            var currentLang = document.documentElement.lang;
            var newLang = locationForm.language.value;

            if (
                (currentLang === 'en-gb' ||
                currentLang === 'en-eu' ||
                currentLang === 'en-int') &&
                (newLang === 'en-us' || newLang === 'en-ca')
            ) {
                var gdprWarning = document.getElementById('js-gdpr-warning');
                var gdprCancel = document.getElementById('js-gdpr-warning-cancel');
                var gdprContinue = document.getElementById('js-gdpr-warning-continue');
                var gdprLang = document.getElementById('js-gdpr-language');
                gdprLang.value = newLang;

                gdprWarning.classList.add('show');
                gdprCancel.addEventListener('click', hideGDPRWarning, false);

                gdprContinue.focus();
            } else {
                redirectUser(locationForm);
            }
        } else if (
            e.target.classList.contains('location-selector-form-gdpr-warning')
        ) {
            redirectUser(e.target);
        }
    }

    document.body.addEventListener('submit', checkLocationSubmit, false);
    document.body.addEventListener('veil:close', hideGDPRWarning, false);
})();

// Sample data
// ===========
// This is an example of the data that we are sending to Heap Analytics...
// heap.track( 'Pub - Add To Cart', {
// 'kitType': 'kit type added',
// 'price': 'price of kit type added',
// 'itemDiscount': 'amount kit is discounted',
// 'locale': 'CA or US'
// 'kitsInCart' 'total kits in cart at time of page load'
// });

// Additional meta data we would like to capture...
// AO_kits: 'total number of AO kits in cart',
// AH_kits: 'total number of A+H kits in cart',
// currentTotal: 'current total cost for kits in cart',
// AH_total: 'current total cost for A+H kits in cart',
// AO_total: 'current total cost for AO kits in cart',
// discount: 'current total amount of discount for kits in cart'

TTAM.heap = (function(){
    'use strict';

    var locale = document.documentElement.lang;
    var pricing;
    var optimizely = {
        isLoaded: function() { return !!(window.optimizely && window.optimizely.get); },
        getCohortData: function() {
            if (!optimizely.isLoaded()) {
                return [];
            }

            var activeCampaigns = Object.values(
                window.optimizely.get('state').getCampaignStates() || {}
            ).filter(function(campaign) { return campaign.isActive; });

            var cohortData = activeCampaigns.map(function(campaign) {
                var data = {};
                var key = campaign.experiment && campaign.experiment.name
                    ? campaign.experiment.name
                    : 'none';
                var value = campaign.variation && campaign.variation.name
                    ? campaign.variation.name
                    : 'none';

                data[key] = value;

                return data;
            });

            return cohortData;
        },
    };

    var optimizelyEdge = {
        isLoaded: function() { return !!(window.optimizelyEdge && window.optimizelyEdge.get); },
        getCohortData: function() {
            if (!optimizelyEdge.isLoaded()) {
                return [];
            }

            var activeCampaigns = Object.values(
                window.optimizelyEdge.get('state').getActiveExperiments() || {}
            );

            var cohortData = activeCampaigns.map(function(campaign) {
                var data = {};
                var key = campaign.name ? campaign.name : 'none';
                var value = campaign.variation && campaign.variation.name
                    ? campaign.variation.name
                    : 'none';

                data[key] = value;

                return data;
            });

            return cohortData;
        },
    };

    function getDiscount(kit) {
        var checkout = {
            'price' : 0,
            'itemDiscount': 0 // default
        };

        if ( pricing[kit+'_discount'] ) { // if there's a discount
            checkout.price = pricing[kit+'_discount'];
            checkout.itemDiscount =  pricing[kit] - checkout.price; // save the discounted value
        } else {
            checkout.price = pricing[kit];
        }
        return checkout;
    }

    function getTargetData(event) {
        if (event.currentTarget.className.indexOf('js-add-to-cart') > -1) {
            var link = event.currentTarget;
            var kitUrl = link.getAttribute('href');
            var kitType = '';
            if (link.getAttribute('data-kit-type')) {
                kitType = link.getAttribute('data-kit-type');
            } else if (kitUrl && kitUrl.indexOf('?') > -1) {
                var kitData = kitUrl.split('?')[1].split('=')[0].split('&')[0]; // widdle it down to just the kit type without qty or coupon codes
                kitType = {
                    'kit': 'health_ancestry',
                    'ancestrykit': 'ancestry',
                    'vipkit': 'vip_health_and_ancestry',
                    'bundle': 'subscription'
                }[kitData];
            }
            if (kitType === '') {
                var kitError = new Error('Heap \'kitType\' error. From page ' + window.location.href + '. Target: ' + link.toString());
                throw (kitError);
            } else if (kitType === 'shop') {
                return '';
            }
            var checkout = getDiscount(kitType);
            trackClickEvent({
                'kitType': kitType,
                'locale': locale,
                'price': checkout.price,
                'itemDiscount': checkout.itemDiscount,
                'kitsInCart': pricing.cart_count
            });
        }
    }

    function trackClickEvent(data){
        window.heap.track('Pub - Add To Cart', data);
    }

    function clickTracker(prices){
        pricing = prices;
        var targets = document.querySelectorAll('.js-add-to-cart');

        for (var i = 0; i < targets.length; i++) {
            targets[i].addEventListener('click', getTargetData, false);
        }
    }

    function getCohortData(){
        if (optimizely.isLoaded()) {
            return optimizely.getCohortData();
        }
        if (optimizelyEdge.isLoaded()) {
            return optimizelyEdge.getCohortData();
        }
        return [];
    }

    function cohortData(){
        if(window.heap){
            var collection = getCohortData();
            $.each(collection, function(){
                window.heap.addUserProperties(this);
            });
        }
    }


    function setHeapUtms() {
        var queryString = window.location.search;
        var utms = [];
        if (!queryString) {
            return;
        }
        queryString = queryString.replace('?', '');

        var params = queryString.split('&');
        params.forEach(function(param){
            var splitParam = param.split('=');
            if (splitParam[0].indexOf('utm_') === 0) {
                utms.push(param);
            }
        });
        //Hack to set cross domain cookie
        var host = window.location.hostname;
        var domain = host.split('.').slice(1, host.length).join('.');
        domain = '.' + domain;
        if (utms.length) {
            TTAM.cookies.set('heap_utms', utms.join('&'), 1/24, domain);
        }
    }
    // public API
    // ==========

    return {
        clickTracker: clickTracker,
        cohortData: cohortData,
        setHeapUtms: setHeapUtms
    };
})();

TTAM.inView = function(el) {
    'use strict';

    // Usage
    //
    // This component checks to see if an element is in view on the viewport
    //
    // Trigger:
    //     TTAM.inView('footer')
    // Returns:
    //     either true or false

    function isElementInView(element) {
        if (element.length === 0) {
            return;
        }
        var $pageTop = $(window).scrollTop();
        var $pageBottom = $pageTop + $(window).height();
        var $elementTop = $(element).offset().top;
        var $elementBottom = $elementTop + $(element).height();

        if (typeof element.height() !== 'number') {
            return;
        }
        return (($elementTop <= $pageBottom) && ($elementBottom >= $pageTop));
    }
    return isElementInView($(el));
};

/**
 * code used both on the service/dna-health-ancestry and the ancestry/dna-ancestry pages
 */
TTAM.kitCarousel = (function(){
    'use strict';

    var $carousel = $('.kit-carousel');

    function activateOverlay(event) {
        var $activeComponent = $('.' + $(event.currentTarget).attr('data-component'), $carousel);

        // show gray background (desktop view only)
        $('.kit-carousel-gray').addClass('js-activated');

        // hide icons (tablet view only) and overlays
        // hide the the learn more links so they cannot be clicked; 
        $('a', '.kit-carousel-overlay').addClass('invisible-link');
        $('.kit-carousel-overlay, .js-icon').removeClass('js-activated');

        // Show/hide default overlay as needed (tablet only)
        if (!$activeComponent.hasClass('default')) {
            $('.default').css('opacity', '0');
        } else {
            $('.default').css('opacity', '1');
        }

        // show selected icon and overlay
        $activeComponent.addClass('js-activated');
        $('a', $activeComponent).removeClass('invisible-link');
    }

    function init(){
        $('.js-overlay-activator').on('click', activateOverlay);
    }

    return {
        init: init
    };

})();
// USAGE
// =====
// <img lazy-load src="{% static 'img/blank.gif' %}" width="30" height="30" alt=""
//   data-src="{% static 'img/foo.svg' %}">
//
// <img lazy-load src="{% static 'img/blank.gif' %}" width="30" height="30" alt=""
//   data-src="{% static 'img/foo.png' %}" data-srcset="{% static 'img/foo_2x.png' %} 2x">
//
// <script>
//     TTAM.lazyLoad.init();
// </script>

// OVERRIDES
// =========
// <script>
//     TTAM.lazyLoad.init({
//         'lazySelector': '.js-lazy',
//         'delayLazyLoadBy': 333
//     });
// </script>

TTAM.lazyLoad = (function(){
    'use strict';

    // private variables
    // =================

    var lazySelector;

    var defaults = {
        // the CSS selector used to identify lazy-load images
        'lazySelector': '[lazy-load]',
        // the time (in milliseconds) between when a window is resized, and images are lazy-loaded
        'delayLazyLoadBy': 400
    };

    // private functions
    // =================

    function loadImage(image){
        var $img = $(image);
        var imgAttrs = {};
        var imgSrc = $img.data('src');
        var imgSrcset = $img.data('srcset');
        // check if image-source has already been replaced
        if(imgSrc !== $img.attr('src')){
            // set image attribute values
            imgAttrs['src'] = imgSrc;
            imgAttrs['srcset'] = imgSrcset;
            // update image attributes
            $img.attr(imgAttrs);
        }
    }

    function updateImages(){
        // loop through selected images (filtering out hidden images)
        $(lazySelector).filter(':visible').each(function(){
            loadImage(this);
        });
    }

    // public API
    // ==========

    return function(configs){
        var settings = $.extend({}, defaults, configs);
        // define values for lazy-selector and loaded-class
        lazySelector = settings.lazySelector;
        // update images on page load
        updateImages();
        // listen for window-resize event
        // just in case images were hidden when page was loaded
        // also adding in async-include:loaded event so async templates with lazy-images will be
        // loaded in after the template has been inserted
        $(window).on('resize async-include:loaded', _.debounce(updateImages, settings.delayLazyLoadBy));
    };
})();

TTAM.marketing = (function() {
    // constants
    // should match the feature switch
    var CAMPAIGN_IDS = {
        'fathers_day': 'js-fathers-day-hero-desktop',
        'full_world_cup': 'js-full-world-cup-desktop',
        'ancestry_hd_hero': 'js-ancestry-hd-hero',
    };
    var WORLD_CUP = 'world-cup';
    var WORLD_CUP_HERO_CLASS = 'show-' + WORLD_CUP;
    var WORLD_CUP_HERO_DEFAULT = WORLD_CUP_HERO_CLASS + '-default';
    var WORLD_CUP_HERO_BUY_ANCESTRY = WORLD_CUP_HERO_CLASS + '-buy-ancestry';
    var WORLD_CUP_HERO_BUY = WORLD_CUP_HERO_CLASS + '-buy';

    var WORLD_CUP_BANNER_SITEWIDE = '.layouts-sitewide.world-cup-sitewide';
    var WORLD_CUP_BANNER_CLASS = 'world-cup-sitewide';
    var WORLD_CUP_BANNER_DEFAULT = WORLD_CUP_BANNER_CLASS + '-default';
    var WORLD_CUP_BANNER_LEARN_MORE = WORLD_CUP_BANNER_CLASS + '-learn-more';

    var PRODUCTS_CONTAINER = '.layouts-products';

    /** name: show_world_cup
     *  description: shows the world cup campaign
     *  button_option: "default" (or empty), "buy ancestry", "buy"
     **/
    function showWorldCupHero(button_option) {
        // TODO: set up button options
        if (!button_option) {
            button_option = 'default';
        }

        var docBody = document.body;
        var products = docBody.querySelectorAll(PRODUCTS_CONTAINER);

        docBody.classList.add(WORLD_CUP_HERO_CLASS);

        for (var i = 0; i < products.length; i++) {
            var current = products[i];
            current.classList.add('mod-' + WORLD_CUP);
        }

        switch(button_option) {
        case 'default':
            docBody.classList.remove(WORLD_CUP_HERO_BUY);
            docBody.classList.remove(WORLD_CUP_HERO_BUY_ANCESTRY);
            docBody.classList.add(WORLD_CUP_HERO_DEFAULT);
            break;
        case 'buy ancestry':
            docBody.classList.remove(WORLD_CUP_HERO_BUY);
            docBody.classList.add(WORLD_CUP_HERO_BUY_ANCESTRY);
            docBody.classList.remove(WORLD_CUP_HERO_DEFAULT);
            break;
        case 'buy':
            docBody.classList.add(WORLD_CUP_HERO_BUY);
            docBody.classList.remove(WORLD_CUP_HERO_BUY_ANCESTRY);
            docBody.classList.remove(WORLD_CUP_HERO_DEFAULT);
            break;
        }

        document.body.classList.remove('opt-1931-option-1');
        document.body.classList.remove('opt-1931-option-2');
        document.body.classList.remove('opt-1931-option-3');
    }

    function showWorldCupHeroDefault() {
        showWorldCupHero('default');
    }

    function showWorldCupHeroBuyAncestry() {
        showWorldCupHero('buy ancestry');
    }

    function showWorldCupHeroBuy() {
        showWorldCupHero('buy');
    }

    function removeWorldCup() {
        document.body.classList.remove(WORLD_CUP_HERO_CLASS);
    }

    function showWorldCupBanner(option) {
        if (!option) {
            option = 'default';
        }

        var banners = [].slice.call(document.querySelectorAll(WORLD_CUP_BANNER_SITEWIDE));

        // make sure we're not calling things against a banner that isn't present
        // on any given page
        if (banners) {
            for (var i = 0; i < banners.length; i++) {
                var banner = banners[i];

                switch(option) {
                case 'default':
                    banner.classList.add(WORLD_CUP_BANNER_DEFAULT);
                    banner.classList.remove(WORLD_CUP_BANNER_LEARN_MORE);
                    break;
                case 'learn more':
                    banner.classList.remove(WORLD_CUP_BANNER_DEFAULT);
                    banner.classList.add(WORLD_CUP_BANNER_LEARN_MORE);
                    break;
                }
            }
        }
    }

    function showWorldCupBannerDefault() {
        showWorldCupBanner('default');
    }

    function showWorldCupBannerLearnMore() {
        showWorldCupBanner('learn more');
    }

    function swapHeroText(campaign, option) {
        var hero = document.getElementById(CAMPAIGN_IDS[campaign]);
        var textA = hero.querySelector('.hero-text-a') || false;
        var textB = hero.querySelector('.hero-text-b') || false;
        var textC = hero.querySelector('.hero-text-c') || false;
        var textD = hero.querySelector('.hero-text-d') || false;

        try {
            switch(option) {
            case 'a':
                textA.classList.remove('u-hide');
                textB ? textB.classList.add('u-hide') : null;
                textC ? textC.classList.add('u-hide') : null;
                textD ? textD.classList.add('u-hide') : null;
                break;
            case 'b':
                textA.classList.add('u-hide');
                textB ? textB.classList.remove('u-hide') : null;
                textC ? textC.classList.add('u-hide') : null;
                textD ? textD.classList.add('u-hide') : null;
                break;
            case 'c':
                textA.classList.add('u-hide');
                textB ? textB.classList.add('u-hide') : null;
                textC ? textC.classList.remove('u-hide') : null;
                textD ? textD.classList.add('u-hide') : null;
                break;
            case 'd':
                textA.classList.add('u-hide');
                textB ? textB.classList.add('u-hide') : null;
                textC ? textC.classList.add('u-hide') : null;
                textD ? textD.classList.remove('u-hide') : null;
                break;
            }
        } catch(err) {
            if (window['newrelic']) {
                try {
                    var customError = new Error('TTAM.marketing: Hero text swap failed');
                    window['newrelic'].noticeError(customError);
                } catch(err2) {
                    // do nothing -- making sure we don't error out on prod
                }
            }
        }
    }

    function fathersDayHeroTextA() {
        swapHeroText('fathers_day', 'a');
    }

    function fathersDayHeroTextB() {
        swapHeroText('fathers_day', 'b');
    }

    function showFifaBanner() {
        var banners = document.querySelectorAll('.u-world-cup-fifa-banner');

        for (var i = 0; i < banners.length; i++) {
            var curBanner = banners[i];

            curBanner.style.display = 'block';
        }
    }

    function paintedDoorTest(type) {
        if (type === 'ha') {
            document.body.classList.add('ha-painted-door-test');
        } else if (type === 'ao') {
            document.body.classList.add('ao-painted-door-test');
        }
    }

    /**
     * @name podcastBanner
     * @description controls the podcast banner for marketing
     * @param {*} style ('default'|'offer'): determines the banner color
     * @param {*} podcastName (optional): name of podcast
     * @param {*} text (optional): text for offers
     * @param {*} url (optional): CTA redirection URL
     * @param {*} buttonText (optional): redurection button text
     */
    function podcastBanner(style, podcastName, text, url, buttonText) {
        style = typeof style !== 'undefined' ? style : 'default';
        podcastName = typeof podcastName !== 'undefined' ? podcastName : 'Podcast';
        text = typeof text !== 'undefined' ? text : 'Get your 23andMe Kit Today';
        url = typeof url !== 'undefined' ? url : '/compare-dna-tests/';
        buttonText = typeof buttonText !== 'undefined' ? buttonText : null;

        try {
            var banner = $('.podcast-banner');
            var name = $('.podcast-banner .podcast-banner-name');
            var bannerText = $('.podcast-banner .podcast-banner-custom-text');
            var sitewide = $('.layouts-sitewide') || null;
            var button = $('.podcast-banner .podcast-banner-button');

            if (style !== 'default') {
                banner.addClass('mod-has-offer');
                button.text(buttonText ? buttonText : 'redeem offer');
            } else {
                banner.removeClass('mod-has-offer');
                button.text(buttonText ? buttonText : 'order now');
            }

            if (podcastName) {
                name.text(podcastName);
            }

            if (text) {
                bannerText.text(text);
            }

            if (url) {
                button.attr('href', url);
            }

            // hide sitewide if it's on the hp
            if (sitewide) {
                sitewide.addClass('u-hide');
            }

            // show podcast banner
            banner.removeClass('u-hide');
        } catch (err) {
            // Do nothing on prod -- probably being called from another page
        }
    }

    function TFOAbove() {
        document.body.classList.add('tfo-above');
    }

    function TFOBelow() {
        document.body.classList.remove('tfo-above');
    }

    return {
        removeWorldCup: removeWorldCup,
        showWorldCupHeroDefault: showWorldCupHeroDefault,
        showWorldCupHeroBuyAncestry: showWorldCupHeroBuyAncestry,
        showWorldCupHeroBuy: showWorldCupHeroBuy,
        showWorldCupBannerDefault: showWorldCupBannerDefault,
        showWorldCupBannerLearnMore: showWorldCupBannerLearnMore,
        fathersDayHeroTextA: fathersDayHeroTextA,
        fathersDayHeroTextB: fathersDayHeroTextB,
        showFifaBanner: showFifaBanner,
        paintedDoorTest: paintedDoorTest,
        podcastBanner: podcastBanner,
        TFOAbove: TFOAbove,
        TFOBelow: TFOBelow,
    };
})();

// USAGE
// =====
// <img match-load width="110" height="40" alt="" data-media="screen and (max-width: 835px)" 
//  data-src="/static/img/foo.svg">
//
// <script>
//     TTAM.matchLoad();
// </script>

// OVERRIDES
// =========
// <script>
//     TTAM.lazyLoad({
//         'lazySelector': '.js-lazy',
//         'delayMatchLoadBy': 333
//     });
// </script>

TTAM.matchLoad = (function() {
    'use strict';

    // private variables
    // =================

    var loadSelector;

    var defaults = {
        // the CSS selector used to identify match-load images
        'loadSelector': '[match-load]',
        // the time (in milliseconds) between when a window is resized, and images are match-loaded
        'delayMatchLoadBy': 400
    };

    function updateImages() {
        // loop through selected images, filtering by mediaQuery
        $(loadSelector).each(function() {
            if (this.dataset.media && window.matchMedia &&
                window.matchMedia(this.dataset.media).matches) {
                for (var attr in this.dataset) {
                    if (attr !== 'media') {
                        this.setAttribute(attr, this.dataset[attr]);
                    }
                }
            }
        });
    }

    // public API
    // ==========

    return function(configs) {
        var settings = $.extend({}, defaults, configs);
        // define values for element selector
        loadSelector = settings.loadSelector;
        // update images on page load
        updateImages();
        // listen for window-resize event
        // and load images if necessary
        $(window).on('resize', _.debounce(updateImages, settings.delayMatchLoadBy));
    };
})();
// Adds handling of hashes in the URL to trigger modals on page load
// Usage http://www.23andme.com/info/#all-reports-list

TTAM.modals = (function() {
    'use strict';

    return function() {
        var modalTypes = [
            '#carrier-status-report-list',
            '#genetic-health-report-list',
            '#trait-report-list',
            '#wellness-report-list',
            '#all-reports-list',
            '#all-reports-list-compare',
            '#fda-info',
            '#all-populations',
            '#user-story-tc',
            '#vip-kit-learn-more-',
            '#vip-kit-learn-more-bar',
            '#vip-kit-learn-more-burger'
        ];
        var hash = window.location.hash;
        if ($.inArray(hash, modalTypes) > -1) {
            $(hash).trigger('veil:show');
        }
    };
})();

/*eslint no-unused-vars: ["error", { "args": "none" }]*/

// Object.assign
if (typeof Object.assign != 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, 'assign', {
        value: function assign(target, varArgs) { // .length of function is 2
            if (target == null) { // TypeError if undefined or null
                throw new TypeError('Cannot convert undefined or null to object');
            }

            var to = Object(target);

            for (var index = 1; index < arguments.length; index++) {
                var nextSource = arguments[index];

                if (nextSource != null) { // Skip over if undefined or null
                    for (var nextKey in nextSource) {
                        // Avoid bugs when hasOwnProperty is shadowed
                        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                            to[nextKey] = nextSource[nextKey];
                        }
                    }
                }
            }
            return to;
        },
        writable: true,
        configurable: true
    });
}

TTAM.stickyCTA = (function() {
    function createStickyCTA() {
        var $triggerPoint = $('#site-header');
        var $stickyCTA = $('.global-sticky-cta');
        var $chromeFooter = $('.chrome-footer');
        var $stickyHeight = $stickyCTA.outerHeight();
        var offset = 220 - $($triggerPoint).outerHeight(); // 220 is value based on example marketing provided

        if ($triggerPoint.length && $stickyCTA.length) {
            // check if elements exist before initializing Waypoint
            new window.Waypoint({
                element: $triggerPoint,
                handler: function(dir) {
                    $stickyCTA.toggleClass('is-sticky');
                    if (dir === 'down') {
                        $chromeFooter.css('padding-bottom', $stickyHeight);
                    } else {
                        $chromeFooter.css('padding-bottom', 0);
                    }
                },
                offset: -offset
            });
        }
    }

    createStickyCTA();
})();

TTAM.stickyNav = (function() {
    'use strict';

    function createStickyNav() {
        var sticky = new window.Waypoint.Sticky({
            element: $('.communities-sticky-nav-outer')[0]
        });

        return sticky;
    }

    function createStickyCTA() {
        var $stickyCta = $('.js-sticky-button');
        var $stickyNav = $('.sticky-wrapper');

        // Show cta only when subnav is sticky
        $stickyNav.waypoint({
            handler: function() {
                $stickyCta.toggleClass('u-hide');
            }
        });
    }

    function createStickyFooter() {
        var $triggerPoint = $('.js-trigger-sticky-footer');
        var $stickyFooter = $('.sticky-footer');
        var offset = $('.js-trigger-sticky-footer').outerHeight(); // only show sticky footer OR enroll button
        // check if trigger-point and sticky-footer elements exist before initializing Waypoint
        if ($triggerPoint.length && $stickyFooter.length) {
            new window.Waypoint({
                element: $triggerPoint,
                handler: function() {
                    $stickyFooter.toggleClass('u-hide');
                },
                offset: -offset
            });
        }
    }

    function styleActiveNavItem() {
        var $navItems = $('.js-nav-link');
        var $sections = $('.js-toc-section');
        var $navHeight = $('.communities-sticky-nav-outer').outerHeight(); // specific to community navs

        // Highlight subnav item when clicked
        $navItems.bind('click', function() {
            $navItems.removeClass('active');
            $(this).addClass('active');
        });

        // Highlight subnav link when section hits top of window
        $sections.each(function(index, section) {
            var id = section.id;
            var menuItem = $('a[href="#' + id + '"]')[0];
            new window.Waypoint({
                element: section,
                // eslint-disable-next-line no-unused-vars
                handler: function(down) {
                    $navItems.removeClass('active');
                    $(menuItem).addClass('active');
                },
                offset: $navHeight + 1 // offset by height of chrome plus a smidge
            });
            // Second Waypoint ccounts for slight offset difference when
            // scrolling UP to the section vs DOWN (note offset)
            new window.Waypoint({
                element: section,
                // eslint-disable-next-line no-unused-vars
                handler: function(up) {
                    $navItems.removeClass('active');
                    $(menuItem).addClass('active');
                },
                offset: $navHeight - 1 // <---offset by height of chrome minus a smidge
            });
        });
    }

    function init() {
        createStickyNav();
        createStickyCTA();
        createStickyFooter();
        styleActiveNavItem();
    }

    return {
        init: init
    };
})();

/**
* Toggle between multiple tabs.
*
* HTML
* ====
*
****** Regular tabs
*
* <div class="tabs-group" role="tablist" tab-group-tabs="header">
*     <div aria-controls="tab01" tabs-tab tab-group-tab="header" role="tab" aria-selected="false" tabindex="1">Tab A</div>
*     <div aria-controls="tab02" tabs-tab tab-group-tab="header" role="tab" aria-selected="false" tabindex="-1">Tab B</div>
* </div>
* <div class="u-hide" role="tabpanel" tab-group-content="header" tab-content="tab01">
*     ...
* </div>
* <div class="u-hide" role="tabpanel" tab-group-content="header" tab-content="tab02">
*     ...
* </div>
*
*
***** Select / Dropdown
*
* <select tabs-dropdown>
*     <option value="tab01">Tab 1</option>
*     <option value="tab02">Tab 2</option>
* </select>
*
*
* JavaScript
* ==========
*
* // initialize
* TTAM.tabs();
*
*
*/

TTAM.tabs = (function(){
    'use strict';

    // constants
    // =========
    var IS_CURRENT_TAB_CLASS = 'is-current-tab';
    var IS_CURRENT_CONTENT_TAB = 'current-content';
    var TRANS_TIMING = 300;
    var KEYS = {
        left: 37,
        up: 38,
        right: 39,
        down: 40,
    };

    // private functions
    // =================

    function getTabList($tab) {
        return $tab.closest('[role="tablist"]');
    }

    function getTabs($tab) {
        var $tabList = getTabList($tab);

        return $('[role="tab"]', $tabList);
    }

    function isTabListVertical($tab) {
        var $tabList = getTabList($tab);

        return $tabList.attr('aria-orientation') === 'vertical';
    }

    function switchTabs(e) {
        e.preventDefault();

        // Interacted tab or dropdown
        var $el = $(this);

        // Set current tab group
        var tabGroup = $el.closest('.tabs-group').attr('tab-group-tabs');
        var tabGroupSelector = '[tab-group-tab='+tabGroup+']';
        var tabId;

        // Remove current styling from all tabs
        // Also manage ARIA
        $(tabGroupSelector).not($el)
            .removeClass(IS_CURRENT_TAB_CLASS)
            .attr({
                'aria-selected': 'false',
                'tabindex': '-1'
            });

        // Add current styling to active tab
        // Also manage ARIA
        $el.addClass(IS_CURRENT_TAB_CLASS);
        $el.attr({
            'aria-selected': 'true',
            'tabindex': '0'
        });
        $el.focus();

        // Determine if tab or dropdown, and determine ID of content
        if ($el[0].hasAttribute('tabs-dropdown')) {
            tabId = $el.val();
        } else {
            tabId = $el.attr('aria-controls');
        }
        // Construct attribute for the content
        var tabContentSelector = '[tab-content='+tabGroup+'-'+tabId+']';

        // Hide and show content (fade out / fade in)
        $('[tab-group-content=' + tabGroup + ']').removeClass(IS_CURRENT_CONTENT_TAB);
        setTimeout(function () {
            $('[tab-group-content='+tabGroup+']').addClass('u-hide');
            $(tabContentSelector).removeClass('u-hide');
            setTimeout(function() {
                $(tabContentSelector).addClass(IS_CURRENT_CONTENT_TAB);
            }, 33);
        }, TRANS_TIMING);
    }

    function focusNextTab($tab) {
        var $tabs = getTabs($tab);
        var tabIndex = $tabs.index($tab);

        if (tabIndex + 1 < $tabs.length) {
            $tabs.eq(tabIndex + 1).focus();
        } else {
            $tabs.eq(0).focus();
        }
    }

    function focusPrevTab($tab) {
        var $tabs = getTabs($tab);
        var tabIndex = $tabs.index($tab);

        if (tabIndex - 1 >= 0) {
            $tabs.eq(tabIndex - 1).focus();
        } else {
            $tabs.eq($tabs.length - 1).focus();
        }
    }

    function focusTab(e) {
        var $tab = $(this);
        var key = e.which;

        if (isTabListVertical($tab)) {
            if (key === KEYS.down) {
                e.preventDefault();
                focusNextTab($tab);
            } else if (key === KEYS.up) {
                e.preventDefault();
                focusPrevTab($tab);
            }
        } else {
            if (key === KEYS.right) {
                focusNextTab($tab);
            } else if (key === KEYS.left) {
                focusPrevTab($tab);
            }
        }
    }

    // public functions
    // ================

    function init() {
        // handle actual tabs
        $('body').unbind('click').on('click', '[tabs-tab]', switchTabs);

        // handle dropdowns instead of tabs
        // Note, they must be nested within '.tabs-group'
        $('body').on('change', '[tabs-dropdown]', switchTabs);

        // handle keyboard arrows
        $('body').on('keydown', '[tabs-tab]', focusTab);

        // set default tab, if one's detected
        $('[tab-group-tabs]').each(function() {
            if ($(this)[0].hasAttribute('tab-default-id')) {
                var defaultTab = $(this).attr('tab-default-id');
                var defaultGroup = $(this).attr('tab-group-tabs');
                $('[tab-group-tabs='+defaultGroup+'] [aria-controls='+defaultTab+']').trigger('click');
            }
        });
    }

    return function() {
        init();
    };
})();

(TTAM.setupTooltips = function() {
    'use strict';

    // Get tooltips
    var $tooltips = $('[data-glossary]');

    // Make sure tooltip is a little smaller than the viewport.
    var maxWidth = 300;
    var windowWidth = $(window).width() - 10;
    var w = windowWidth < maxWidth ? windowWidth : maxWidth;

    // Define the default Tipped skin
    $.extend(Tipped.Skins, {
        'ttam-light': {
            maxWidth: w,
            behavior: 'hide'
        }
    });

    // Set the default skin.
    Tipped.setDefaultSkin('ttam-light');

    // Provide keyboard support
    $tooltips.on('focus', function(e) {
        Tipped.show(e.target);
    });
    $tooltips.on('blur', function(e) {
        Tipped.hide(e.target);
    });
    $tooltips.on('click', function(e) {
        e.preventDefault();
    });
})();
// USAGE

// Control
// <a href="{% service_url 'store' %}?ancestrykit=1" data-upgrade-url="none">add to cart</a>

// A/B test version 1
// <a href="{% service_url 'store' %}?ancestrykit=1" data-upgrade-url="/upgrade/?v=1">add to cart</a>

// A/B test version 2
// <a href="{% service_url 'store' %}?ancestrykit=1" data-upgrade-url="/upgrade/?v=2">add to cart</a>

TTAM.upgradeButton = (function(){
    'use strict';

    // constants
    // =========

    var UPGRADE_BUTTON_SELECTOR = '[data-upgrade-url]';

    // private functions
    // =================

    function handleUpgradeButton(event){
        var upgradeUrl = $(event.currentTarget).data('upgradeUrl');
        // make sure data-layer is in global scope
        window.dataLayer = window.dataLayer || [];
        // add event to data-layer
        window.dataLayer.push({
            'event': 'AnalyticsEvent',
            'eventCategory': 'pubsite',
            'eventAction': 'Ancestry Purchase Click',
            'eventLabel': upgradeUrl
        });
        if(upgradeUrl === 'none'){
            return; // do nothing
        } else {
            event.preventDefault(); // prevent default navigation
            window.location = upgradeUrl; // redirect to upgrade page
        }
    }

    function init(){
        // listen for upgrade-button click
        $('body').on('click', UPGRADE_BUTTON_SELECTOR, handleUpgradeButton);
    }

    // public API
    // ==========

    return function(){
        // initialize component
        init();
    };

})();

/**
* Veils document with modal.
*
* HTML
* ====
*
* <button aria-controls="my-modal" data-veil="toggle">toggle</button>
*
* <div id="my-modal" class="veil" aria-hidden="true" role="dialog" tabindex="-1" data-veil="modal">
*     <button aria-controls="my-modal" data-veil="toggle">close</button>
* </div>
*
* JavaScript
* ==========
*
* // initialize
* TTAM.veil();
*
* // open programmatically
* $(document).ready(function(){
*     $('#my-modal').trigger('veil:show');
* });
*
* // close programmatically
* $(document).ready(function(){
*     $('#my-modal').trigger('veil:hide');
* });
*
*/
// CustomEvent polyfill
(function () {
    if ( typeof window.CustomEvent === 'function' ) return false;

    function CustomEvent ( event, params ) {
        params = params || { bubbles: false, cancelable: false, detail: undefined };
        var evt = document.createEvent( 'CustomEvent' );
        evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
})();

TTAM.veil = (function(){
    'use strict';

    // constants
    // =========

    var IS_ACTIVE_CLASS = 'is-active';
    var IS_VEILED_CLASS = 'is-veiled';
    var VEIL_OVERLAY_SELECTOR = '.veil-overlay';
    var KEYS = {
        esc: 27,
    };

    // private variables
    // =================

    var defaults = {
        'veilSelector': '[data-veil=toggle]',
        'modalSelector': '[data-veil=modal]'
    };
    var $body = $('body');
    var currentModal, resizeTimer;
    var focusTraps = {};

    // prevent modal animations (CSS) from happening during window resizes
    // ===============
    $(window).on('resize', _.debounce(function() {
        $('.veil').addClass('u-noanimation');
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            $('.veil').removeClass('u-noanimation');
        }, 250);
    }));


    // private functions
    // =================

    function getFocusTrap(modal) {
        if (typeof focusTraps[modal.id] === 'undefined') {
            focusTraps[modal.id] = new TTAM.focusTrap(modal);
        }

        return focusTraps[modal.id];
    }

    function modifyClassName(name, veilType){
        var modified = name;
        if(veilType){
            modified += '-' + veilType;
        }
        return modified;
    }

    function slide(modal, open){
        var veilBlur = $(modal).data('veilBlur');
        var veilType = $(modal).data('veilType');
        var activeClass = modifyClassName(IS_ACTIVE_CLASS, veilType);
        var veiledClass = modifyClassName(IS_VEILED_CLASS, veilType);
        var focusTrap = getFocusTrap(modal);

        // open or close modal
        $(modal).toggleClass(activeClass, open).attr('aria-hidden', open ? 'false' : 'true');
        // disable or enable document scrolling
        $body.toggleClass(veiledClass, open);

        // shift focus to modal when first opened
        if(open){
            var veilOpenEvent = new CustomEvent('veil:open', {
                bubbles: true,
                detail: {
                    'veiledClass': veiledClass,
                }
            });
            modal.dispatchEvent(veilOpenEvent);

            $(modal).focus();
            focusTrap.enable();

            // add overlay to darken content beneath the modal
            overlay(true);
        } else if (!open) {
            var veilCloseEvent = new CustomEvent('veil:close', {
                bubbles: true,
                detail: {
                    'veiledClass': veiledClass,
                }
            });
            modal.dispatchEvent(veilCloseEvent);

            focusTrap.disable();

            // remove overlay
            overlay(false);

            // shift focus back to document
            if(veilBlur){
                $(veilBlur).focus();
            }
        }
    }

    function toggle(event){
        event.preventDefault();

        var id = $(event.currentTarget).attr('aria-controls');
        currentModal = id;
        var modal = document.getElementById(id);
        var hidden = $(modal).attr('aria-hidden') === 'true';
        // if modal is hidden, then save blur-element
        if(hidden){
            $(modal).data('veilBlur', event.currentTarget);
        }
        // show or hide modal based on hidden-state
        slide(modal, hidden);
    }

    // Overlay that sits on top of content to darken
    // Usage: overlay(true);
    function overlay(show) {
        var veilOverlayMarkup = '<div class="veil-overlay"></div>';
        if (show) {
            $body.prepend(veilOverlayMarkup);
            setTimeout(function() {
                var $veilOverlay = $body.find(VEIL_OVERLAY_SELECTOR);

                if ($veilOverlay.length) {
                    // on mobile iOS Safari this prevents scrolling since
                    // position: fixed causes the page to scroll to the top
                    $veilOverlay.on('touchmove scroll', function(e) {
                        e.preventDefault();
                        e.stopPropagation();
                    });

                    $veilOverlay.addClass('veil-overlay-showing');
                    // clicking or tapping this overlay closes the modal
                    $veilOverlay.attr({
                        'aria-controls': currentModal,
                        'data-veil': 'toggle'
                    });
                }
            }, 1);
        }
        if (!show) {
            var $veilOverlay = $(VEIL_OVERLAY_SELECTOR);
            $veilOverlay.removeClass('veil-overlay-showing');
            setTimeout(function() {
                // clean up events to prevent memory issues
                $veilOverlay.off('touchmove scroll');

                $veilOverlay.remove();
            // if this timing changes, it must also change in _veil.scss
            }, 500);
        }
    }

    function init(settings){
        // listen for click event
        $body.on('click', settings.veilSelector, toggle);
        // listen for esc key
        $body.on('keyup', settings.modalSelector, function(event) {
            var key = event.which || event.keyCode;

            if (key === KEYS.esc) {
                slide(this, false);
                currentModal = event.target.id;
            }
        });
        // listen for custom events ('veil:show' and 'veil:hide')
        $(settings.modalSelector).on('veil:show', function(event){
            slide(this, true);
            currentModal = event.target.id;
        }).on('veil:hide', function(){
            slide(this, false);
            currentModal = event.target.id;
        });
    }

    // public API
    // ==========

    return function(configs){
        var settings = $.extend({}, defaults, configs);
        // initialize component
        init(settings);
    };

})();

TTAM.videos = (function () {
    'use strict';
    // youtube iframe API
    // https://developers.google.com/youtube/iframe_api_reference#Getting_Started
    var YOUTUBE_SCRIPT_URL = 'https://www.youtube.com/iframe_api';
    var apiCalls = 0;
    var apiCallDelay = 300;
    var maxApiCalls = 5;
    var ytPlayers = {};
    var apiLoading = false;
    var apiReady = false;

    // constructor
    var YoutubePlayer = function(el) {
        var $el = $(el);

        this.el = el;
        this.videoId = $el.data('youtube');
        this.style = $el.attr('style');
        this.playerId = this.videoId + '-player';
        this.YT = window.YT;
    };

    // private functions
    // =================

    YoutubePlayer.prototype.init = function () {
        var origin = this._getOrigin();

        // create <iframe> after API code downloads
        this.player = new this.YT.Player(this.playerId, {
            height: '100%',
            width: '100%',
            videoId: this.videoId,
            playerVars: {
                'autohide': 1,// hide controls after play starts
                'showinfo': 0,// hide title and uploader
                'disablekb': 1,// oddly, 1 enables keyboard controls
                'wmode': 'transparent', // for IE z-index bug
                'origin': origin// ALWAYS: adds security regarding videos domain
            },
            events: {
                'onStateChange': this._onPlayerStateChange.bind(this),
                'onError': this._onPlayerError.bind(this),
                'onReady': this._onPlayerReady.bind(this)
            }
        });
    };

    YoutubePlayer.prototype._onPlayerReady = function () {
        var $el = $(this.el);

        $el.find('.js-play-video').on('click', this._openVideo.bind(this));
        $el.find('.js-close-video').on('click', this._closeVideo.bind(this));
    };

    YoutubePlayer.prototype._onPlayerStateChange = function (event) {
        // auto close video when done
        if (event.data == this.YT.PlayerState.ENDED) {
            this._closeVideo();
        }
        // if video is playing, bind video height resize to window resize
        if (event.data === this.YT.PlayerState.PLAYING) {
            $(window).on('resize.enabled', _.debounce(this._resizeVideo.bind(this), 100));
        }
    };

    YoutubePlayer.prototype._onPlayerError = function () {
        // show default error message and auto-close
        setTimeout(this._closeVideo, 2000);
    };

    YoutubePlayer.prototype._getOrigin = function () {
        var loc = window.location;

        // for IE support - does not always have location.origin
        return loc.origin || loc.protocol + '//' + loc.hostname + (loc.port ? ':' + loc.port : '');
    };

    // set height of player to full page
    // subtracts page header from window height to set height of player
    YoutubePlayer.prototype._resizeVideo = function () {
        var $el = $(this.el);
        var winHeight = $(window).height();
        // If there is a sticky bottom, it should have the id of "sticky-bottom"
        // If so, it will calculate it's height and take it into account
        var stickyHeight = $('#sticky-bottom').outerHeight();
        if (stickyHeight === 'undefined') stickyHeight = 0;
        if ($el.data('has-header') === false) {
            $el.height(winHeight - stickyHeight);
        } else  {
            // adjust height to new window height (minus header)
            $el.height(winHeight - $('.js-ttam-header').height() - stickyHeight);
        }
    };

    YoutubePlayer.prototype._stopVideo = function () {
        // putting in check, because it was throwing exception
        if (this.player && this.player.stopVideo) {
            this.player.stopVideo();
        }
    };

    YoutubePlayer.prototype._openVideo = function () {
        var $el = $(this.el);
        var $closeEl = $el.find('.js-close-video');
        this._resizeVideo();
        this.player.playVideo();

        // handle UI on video open
        $closeEl.addClass('active');
        $closeEl.get(0).focus();
        $el.find('.js-title')
            .addClass('is-hidden')
            .attr('aria-hidden', 'true');
        $el.addClass('is-open');
        $('#' + this.playerId).addClass('is-playing');
        $el.find('.js-play-video').attr('tabindex', '-1');

        // handle ESC key
        $(document).on('keyup.' + this.playerId, this._handleEscape.bind(this));
    };

    YoutubePlayer.prototype._closeVideo = function () {
        var $el = $(this.el);

        this._stopVideo();

        // handle UI on stop
        $el.find('.js-close-video').removeClass('active');
        $el.find('.js-title')
            .removeClass('is-hidden')
            .removeAttr('aria-hidden');
        $('#' + this.playerId).removeClass('is-playing');
        $el.removeClass('is-open');
        $el.attr('style', this.style);// reset slide styles
        $el.find('.js-play-video').removeAttr('tabindex').focus();

        // unbind esc key event
        $(document).off('keyup.' + this.playerId);

        // unbind the resize event
        $(window).off('resize.enabled');
    };

    YoutubePlayer.prototype._handleEscape = function (event) {
        var key = event.which || event.keyCode;

        if (key === 27) {
            this._closeVideo();
            event.stopPropagation();
        }
    };

    function _loadYoutubeAPI() {
        if (apiLoading || apiReady) {
            return;
        }
        apiLoading = true;
        // inject script
        $.ajax({
            url: YOUTUBE_SCRIPT_URL,
            dataType: 'script',
            cache: true,
            complete: function (xhr, status) {
                // if API load fails, retry
                var badStates = ['nocontent', 'error', 'timeout', 'abort', 'parsererror'];
                var i;
                var foundError = false;

                for (i = 0; i < badStates.length; i++) {
                    // call the API again
                    if (status === badStates[i] && maxApiCalls > apiCalls++) {
                        setTimeout(_loadYoutubeAPI, apiCallDelay);
                        foundError = true;
                        break;// no need to look for another
                    }
                }
                if (!foundError) {
                    apiReady = true;
                    apiLoading = false;
                }
            }
        });
    }

    // initialize the youtube Player...
    function _initPlayer(ytElement) {
        var $yt = $(ytElement);
        var playerError = 'videos._initPlayer() error: ';
        var videoId, noPlayerId, ytPlayer;

        // if no videoId, throw an exception
        videoId = $yt.data('youtube');
        if (!videoId) {
            throw playerError + 'element does not contain a "data-youtube" attribute';
        }
        // if no $('#' + videoId + '-player') element, throw an exception
        noPlayerId = $yt.find('#' + videoId + '-player').length === 0;
        if (noPlayerId) {
            throw playerError + 'element does not contain a child with id "[videoId]-player"';
        }

        // make sure it is not already initialized
        if (!$yt.find('iframe#' + videoId + '-player').length) {
            ytPlayer = new YoutubePlayer(ytElement);
            ytPlayer.init();
            // add each player to the ytPlayers
            ytPlayers[videoId] = ytPlayer;
        }
    }

    // public API
    // ==========
    /** Usage:
     *
     *  To inintialize pass a selector parameter of the element containing a data-youtube attribute
     *
     *  Examples:
     *      TTAM.ready(function () {
     *          TTAM.videos.init('#eWut-W_tY7');
     *      });
     *  or
     *      TTAM.ready(function () {
     *          TTAM.videos.init('#anId .aClass');
     *      });
     *
     *  To close all videos (ex. your carousel switches videos, and you want to shut off the
     *  previous video before you switch)
     *
     *      TTAM.ready(function () {
     *          TTAM.videos.closeAll();
     *      });
     *
     */

    // initialize video(s) within a parent css selector
    function init(selector) {
        var $yt;// elements with data-youtube
        var initErr = 'videos.init() error: ';

        // Load the YT iFrame API
        _loadYoutubeAPI();
        if (selector) {
            $yt = $(selector);
        } else {
            throw initErr + 'no selector parameter for video';
        }
        if (!$yt.length) {
            throw initErr + '"' + selector + '"' + ' is an invalid selector parameter for video';
        }

        // loop through any youtube elements and initialize any uninitialized ones
        $yt.each(function () {
            var yt = this;

            if (apiReady) {
                _initPlayer(yt);
            } else {
                window.onYouTubeIframeAPIReady = function () {
                    apiReady = true;
                    _initPlayer(yt);
                };
            }
        });
    }

    // will close all players on the page
    function closeAll() {
        _.forOwn(ytPlayers, function (player, videoId) {
            if ($(player.el).find('iframe#' + videoId + '-player').length) {
                player._closeVideo();
            } else {
                delete ytPlayers[videoId];
            }
        });
    }

    return {
        init: init,
        closeAll: closeAll
    };
})();

//# sourceMappingURL=components.js.map